<div class="reporting-container">
  <!-- Header with case information -->
  <div class="case-header">
    <span class="case-number">{{probate?.probateId || 'Loading...'}}</span>
    <span class="case-divider">|</span>
    <span class="case-name">{{probate?.deceasedName || 'Loading...'}}</span>
    <span class="case-divider">|</span>
    <span class="case-address">{{probate?.addresses?.[0]?.address || (probate?.probateId ? 'No address available' : 'Loading...')}}</span>
    <button class="notes-btn" (click)="openNotes()" title="View / Edit Notes">
      NOTES
      <span class="notes-count-badge" *ngIf="notes.length > 0">{{ notes.length }}</span>
    </button>
    <button class="layout-toggle-btn" (click)="toggleLayout()" [class.expanded]="isLayoutExpanded"
            [title]="isLayoutExpanded ? 'Show PDF Panel' : 'Hide PDF Panel'">
      <span class="collapse-icon">{{isLayoutExpanded ? '<' : '>' }}</span>
    </button>
  </div>

  <!-- Main content area -->
  <div class="main-content" [class.expanded]="isLayoutExpanded">
    <!-- Left side - Form -->
    <div class="form-section">
      <!-- Tab buttons -->
      <div class="tab-container">
        <!-- Bequest tabs only show when Will tab is selected -->
        <button class="tab-button bequest-tab" *ngIf="activeTab && activeTab.type == 'will'"
          [class.active]="activeBequestTab == 'will-general'" (click)="setBequestTab('will-general')">
          Will General
        </button>
        <button class="tab-button bequest-tab" *ngIf="activeTab && activeTab.type == 'will'"
          [class.active]="activeBequestTab == 'charitable'" (click)="setBequestTab('charitable')">
          Charitable Bequests
        </button>
        <button class="tab-button bequest-tab" *ngIf="activeTab && activeTab.type == 'will'"
          [class.active]="activeBequestTab == 'non-charitable'" (click)="setBequestTab('non-charitable')">
          Non-Charitable Bequests
        </button>
        <button class="save-btn-tab-bar" (click)="onSave()" title="Save all changes">
          SAVE
        </button>
      </div>

      <!-- Grant Reporting Form -->
      <div class="form-content" *ngIf="activeTab && activeTab.type == 'probate'">
        <form class="reporting-form" (input)="markAsChanged()" (change)="markAsChanged()">

          <!-- Top Fields: Probate ID, Date of Probate and Type of Grant -->
          <div class="top-fields">
            <div class="top-field">
              <label class="form-label">Probate ID</label>
              <input type="text" class="form-input" [(ngModel)]="editableProbate.caseReferenceNumber"
                name="probateId" readonly />
            </div>
            <div class="top-field">
              <label class="form-label">Date of Probate</label>
              <input type="text" class="form-input" [(ngModel)]="editableProbate.dateOfIssue" name="dateOfIssue"
                placeholder="DD/MM/YYYY" />
            </div>
            <div class="top-field">
              <label class="form-label">Type of Grant</label>
              <input type="text" class="form-input" [(ngModel)]="editableProbate.typeOfGrant" name="typeOfGrant" />
            </div>
          </div>

          <!-- Deceased Section -->
          <div class="static-section">
            <div class="static-section-header">
              <h3 class="section-title" style="margin: 0; border: none; padding: 0;">Deceased</h3>
            </div>
              <div class="section-content two-column-form">
                <!-- Title, Full Name, After Title on same row -->
                <div class="form-row full-width date-age-row">
                  <div class="date-field">
                    <label class="form-label">Title</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.title" name="title"
                      [matAutocomplete]="autoTitle" placeholder="Select or type Title" />
                    <mat-autocomplete #autoTitle="matAutocomplete">
                      <mat-option value="Mr">Mr</mat-option>
                      <mat-option value="Mrs">Mrs</mat-option>
                      <mat-option value="Miss">Miss</mat-option>
                      <mat-option value="Ms">Ms</mat-option>
                      <mat-option value="Dr">Dr</mat-option>
                      <mat-option value="Professor">Professor</mat-option>
                      <mat-option value="Sir">Sir</mat-option>
                      <mat-option value="Lady">Lady</mat-option>
                      <mat-option value="Reverend">Reverend</mat-option>
                      <mat-option value="Captain">Captain</mat-option>
                      <mat-option value="Dame">Dame</mat-option>
                      <mat-option value="Father">Father</mat-option>
                    </mat-autocomplete>
                  </div>
                  <div class="date-field">
                    <label class="form-label">Full Name</label>
                    <input type="text" class="form-input" [(ngModel)]="probate.deceasedName"
                      name="fullName" />
                  </div>
                  <div class="date-field">
                    <label class="form-label">After Title</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.afterTitle" name="afterTitle" />
                  </div>
                </div>

                <!-- Also Known As Section -->
                <!-- Also Known As Grid (2 columns) -->
                <div class="also-known-grid full-width">

                  @for(alias of probate.aliases; track $index; let i = $index){
                  <div class="also-known-item">
                    <label class="form-label also-known-label">Also Known As {{ i + 1 }}</label>
                    <div class="also-known-input-row">
                      <input type="checkbox" [checked]="selectedAliasIndices.has(i)" 
                             (change)="toggleAliasSelection(i)" 
                             name="selectAlias{{i}}" class="name-checkbox" />
                      <input type="text" class="form-input name-input" [(ngModel)]="probate.aliases[i]" name="alias{{i}}"/>
                    </div>
                  </div>
                  }

                  <!-- Also Known As 1 -->
                  <!--<div class="also-known-item">
    <label class="form-label also-known-label">Also Known As 1</label>
    <div class="also-known-input-row">
      <input type="checkbox" [(ngModel)]="firstAlsoKnownAsSelected" name="selectFirstAlsoKnownAs"
             class="name-checkbox" />
      <input type="text" class="form-input name-input"
        [(ngModel)]="editableProbate.allNamesWhichTheDeceasedWasOtherwiseKnownAs" name="alsoKnownAs" />
    </div>
  </div>-->
                  <!-- Alternative Names -->
                  <!--@for(altName of alternativeNames; track altName.trackingId; let i = $index)
  {
  <div class="also-known-item">
    <label class="form-label also-known-label">Also Known As {{ i + 2 }}</label>
    <div class="also-known-input-row">
      <input type="checkbox" [(ngModel)]="altName.selected" name="selectAltName{{altName.trackingId}}"
             class="name-checkbox" />
      <input type="text" class="form-input name-input" [(ngModel)]="altName.name"
             name="alternativeName{{altName.trackingId}}" />
    </div>
  </div>
  }-->
                  <!-- Buttons at bottom left -->
                  <div class="also-known-buttons-container">
                    <button type="button" class="btn btn-secondary add-btn" (click)="addAlternativeName()">
                      Add Name
                    </button>
                    <button type="button" class="btn add-btn" [class.btn-primary]="hasSelectedAlternativeNames()"
                            [class.btn-secondary]="!hasSelectedAlternativeNames()" (click)="removeSelectedAlternativeNames()"
                            [disabled]="!hasSelectedAlternativeNames()">
                      Remove Selected
                    </button>
                  </div>
                </div>

                <!-- Gender, DOB, DOD, Age on same row -->
                <div class="form-row full-width date-age-row">
                  <div class="date-field">
                    <label class="form-label">Gender</label>
                    <select class="form-input short" [(ngModel)]="selectedGender" name="gender"
                      (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                      <option value="">Select</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                      <option value="O">Other</option>
                    </select>
                  </div>
                  <div class="date-field">
                    <label class="form-label">DOB</label>
                    <input type="text" class="form-input short" [(ngModel)]="editableProbate.dateOfBirth"
                      name="dateOfBirth" placeholder="DD/MM/YYYY" />
                  </div>
                  <div class="date-field">
                    <label class="form-label">DOD</label>
                    <input type="text" class="form-input short" [(ngModel)]="editableProbate.dateOfDeath"
                      name="dateOfDeath" placeholder="DD/MM/YYYY" />
                  </div>
                  <div class="date-field">
                    <label class="form-label">Age</label>
                    <input type="text" class="form-input short" [value]="calculateAge()" name="age" readonly />
                  </div>
                </div>

                <!-- Relationship to Relative -->
                <div class="form-row full-width" style="margin-top: 5px; gap: 0;">
                  <label class="form-label" style="margin-bottom: 12px;">DESCRIPTION OF DECEASED</label>
                  <div style="display: flex; gap: 8px; align-items: center;">
                    <select class="form-input" [(ngModel)]="relationToRelative" name="relationToRelative"
                      style="width: auto; min-width: 130px;">
                      <option value="">-- select --</option>
                      <option value="wife of">wife of</option>
                      <option value="husband of">husband of</option>
                      <option value="widow of">widow of</option>
                      <option value="widower of">widower of</option>
                      <option value="sister of">sister of</option>
                      <option value="brother of">brother of</option>
                      <option value="partner of">partner of</option>
                      <option value="cousin of">cousin of</option>
                      <option value="son of">son of</option>
                      <option value="daughter of">daughter of</option>
                    </select>
                    <input type="text" class="form-input" [(ngModel)]="relativePersonName"
                      name="relativePersonName" placeholder="Relative's name"
                      style="flex: 1; min-width: 340px;"
                      (dblclick)="openTextPopup('relativePersonName')"
                      title="Double-click to expand" />
                  </div>
                </div>
              </div>
          </div>

          <!-- Deceased Address Section -->
          <div class="static-section">
            <div class="static-section-header">
              <h3 class="section-title" style="margin: 0; border: none; padding: 0;">Deceased Address</h3>
            </div>
              <div class="section-content">
                <!-- Address, Town, County, Postcode, Country on same row -->
                <div class="form-row full-width date-age-row">
                  <div class="date-field" style="flex: 2;">
                    <label class="form-label">Address</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.deceasedAddress"
                      name="deceasedAddress"
                      (dblclick)="openTextPopup('deceasedAddress_address')"
                      title="Double-click to expand" />
                  </div>
                  <div class="date-field">
                    <label class="form-label">Town</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.deceasedTown"
                      name="deceasedTown"
                      (dblclick)="openTextPopup('deceasedAddress_town')"
                      title="Double-click to expand" />
                  </div>
                  <div class="date-field">
                    <label class="form-label">County</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.deceasedCounty"
                      name="deceasedCounty"
                      (dblclick)="openTextPopup('deceasedAddress_county')"
                      title="Double-click to expand" />
                  </div>
                  <div class="date-field">
                    <label class="form-label">Postcode</label>
                    <input type="text" class="form-input short" [(ngModel)]="editableProbate.deceasedPostcode"
                      name="deceasedPostcode"
                      (dblclick)="openTextPopup('deceasedAddress_postcode')"
                      title="Double-click to expand" />
                  </div>
                  <div class="date-field">
                    <label class="form-label">Country</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.deceasedCountry"
                      name="deceasedCountry"
                      (dblclick)="openTextPopup('deceasedAddress_country')"
                      title="Double-click to expand" />
                  </div>
                </div>
              </div>
          </div>

          <!-- Executors Section -->
          <div class="static-section">
            <div class="static-section-header">
              <h3 class="section-title" style="margin: 0; border: none; padding: 0;">Executors {{executors.length}}</h3>
            </div>
              <div class="section-content">
                <mat-accordion multi="false" class="executor-sub-accordion">
                  @for(executor of executors; track executor.trackingId)
                  {
                  <mat-expansion-panel>
                    <mat-expansion-panel-header class="panelHeader">
                      <mat-panel-title>
                        <table>
                          <tr>
                            <td>{{executor.name || 'New Executor'}}</td>
                          </tr>
                        </table>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="executor-content">
                      <!-- Row 1: Executor Name | Address -->
                      <div class="executor-row-2col">
                        <div class="executor-field">
                          <label class="form-label">Executor Name</label>
                          <input type="text" class="form-input" [(ngModel)]="executor.name"
                                 name="executorName{{executor.trackingId}}"
                                 (dblclick)="openTextPopup('executor_name', executor.trackingId)"
                                 title="Double-click to expand" />
                        </div>
                        <div class="executor-field">
                          <label class="form-label">Address</label>
                          <input type="text" class="form-input" [(ngModel)]="executor.address"
                                 name="executorAddress{{executor.trackingId}}"
                                 (dblclick)="openTextPopup('executor_address', executor.trackingId)"
                                 title="Double-click to expand" />
                        </div>
                      </div>

                      <!-- Row 2: Town | County | Postcode | Country -->
                      <div class="executor-row-4col">
                        <div class="executor-field">
                          <label class="form-label">Town</label>
                          <input type="text" class="form-input" [(ngModel)]="executor.town"
                                 name="executorTown{{executor.trackingId}}"
                                 (dblclick)="openTextPopup('executor_town', executor.trackingId)"
                                 title="Double-click to expand" />
                        </div>
                        <div class="executor-field">
                          <label class="form-label">County</label>
                          <input type="text" class="form-input" [(ngModel)]="executor.county"
                                 name="executorCounty{{executor.trackingId}}"
                                 (dblclick)="openTextPopup('executor_county', executor.trackingId)"
                                 title="Double-click to expand" />
                        </div>
                        <div class="executor-field">
                          <label class="form-label">Postcode</label>
                          <input type="text" class="form-input" [(ngModel)]="executor.postcode"
                                 name="executorPostcode{{executor.trackingId}}"
                                 (dblclick)="openTextPopup('executor_postcode', executor.trackingId)"
                                 title="Double-click to expand" />
                        </div>
                        <div class="executor-field">
                          <label class="form-label">Country</label>
                          <input type="text" class="form-input" [(ngModel)]="executor.country"
                                 name="executorCountry{{executor.trackingId}}"
                                 (dblclick)="openTextPopup('executor_country', executor.trackingId)"
                                 title="Double-click to expand" />
                        </div>
                      </div>

                      <!-- Remove button -->
                      <div class="executor-remove-btn">
                        <button type="button" class="btn btn-secondary" (click)="removeExecutor(executor.trackingId)">
                          Remove Executor
                        </button>
                      </div>
                    </div>

                  </mat-expansion-panel>
                  }
                </mat-accordion>

                <button type="button" class="btn btn-secondary add-btn" (click)="addExecutor()"
                  style="margin-top: 15px; display: block;">
                  Add Executor
                </button>
              </div>
          </div>

          <!-- Estate Value Section -->
          <div class="static-section">
            <div class="static-section-header">
              <h3 class="section-title" style="margin: 0; border: none; padding: 0;">Estate Value</h3>
            </div>
              <div class="section-content">
                <!-- Gross and Net on same row -->
                <div class="form-row full-width date-age-row estate-value-row">
                  <div class="date-field">
                    <label class="form-label">Gross Value</label>
                    <div class="currency-input-wrapper">
                      <span class="currency-prefix">£</span>
                      <input type="text" class="form-input currency-input" [(ngModel)]="editableProbate.grossFormatted"
                        name="gross" (input)="onGrossChange($event)" />
                    </div>
                  </div>
                  <div class="date-field">
                    <label class="form-label">Net Value</label>
                    <div class="currency-input-wrapper">
                      <span class="currency-prefix">£</span>
                      <input type="text" class="form-input currency-input" [(ngModel)]="editableProbate.netFormatted"
                        name="net" (input)="onNetChange($event)" />
                    </div>
                  </div>
                </div>
              </div>
          </div>

          <!-- Extracted By Section (Solicitor Information) -->
          <div class="static-section">
            <div class="static-section-header">
              <h3 class="section-title" style="margin: 0; border: none; padding: 0;">Extracted By</h3>
            </div>
              <div class="section-content">
                <!-- Row 1: Solicitor Name, Reference, Address -->
                <div class="form-row full-width date-age-row">
                  <div class="date-field">
                    <label class="form-label">Solicitor Name</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.solicitorName"
                      name="solicitorName"
                      (dblclick)="openTextPopup('solicitor_name')"
                      title="Double-click to expand" />
                  </div>
                  <div class="date-field">
                    <label class="form-label">Reference</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.solicitorReference"
                      name="solicitorReference"
                      (dblclick)="openTextPopup('solicitor_reference')"
                      title="Double-click to expand" />
                  </div>
                  <div class="date-field" style="flex: 2;">
                    <label class="form-label">Address</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.solicitorAddress"
                      name="solicitorAddress"
                      (dblclick)="openTextPopup('solicitor_address')"
                      title="Double-click to expand" />
                  </div>
                </div>
                <!-- Row 2: Town, County, Postcode, Country - aligned with row 1 -->
                <div class="form-row full-width date-age-row">
                  <div class="date-field">
                    <label class="form-label">Town</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.solicitorTown"
                      name="solicitorTown"
                      (dblclick)="openTextPopup('solicitor_town')"
                      title="Double-click to expand" />
                  </div>
                  <div class="date-field">
                    <label class="form-label">County</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.solicitorCounty"
                      name="solicitorCounty"
                      (dblclick)="openTextPopup('solicitor_county')"
                      title="Double-click to expand" />
                  </div>
                  <div class="date-field">
                    <label class="form-label">Postcode</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.solicitorPostcode"
                      name="solicitorPostcode"
                      (dblclick)="openTextPopup('solicitor_postcode')"
                      title="Double-click to expand" />
                  </div>
                  <div class="date-field">
                    <label class="form-label">Country</label>
                    <input type="text" class="form-input" [(ngModel)]="editableProbate.solicitorCountry"
                      name="solicitorCountry"
                      (dblclick)="openTextPopup('solicitor_country')"
                      title="Double-click to expand" />
                  </div>
                </div>
              </div>
          </div>

        </form>
      </div>

      <!-- Will General Content -->
      <div class="form-content" *ngIf="activeTab && activeTab.type == 'will' && activeBequestTab == 'will-general'">
        <form class="reporting-form" (input)="markAsChanged()" (change)="markAsChanged()">

          <!-- General Section -->
          <div class="static-section">
            <div class="static-section-header">
              <h3 class="section-title" style="margin: 0; border: none; padding: 0;">General</h3>
            </div>
              <div class="section-content">
                <div class="form-row full-width date-age-row" style="justify-content: flex-start; gap: 24px; align-items: flex-end;">
                  <div class="date-field" style="flex: 0 0 180px; max-width: 180px;">
                    <label class="form-label">Date of Will</label>
                    <input type="text" class="form-input" [(ngModel)]="editableWill.dateOfWill" name="dateOfWill"
                      placeholder="DD/MM/YYYY" />
                  </div>
                  <div class="date-field codicil-dates-field">
                    <label class="form-label">Codicil Date(s)</label>
                    <div class="codicil-display-row">
                      <!-- 0 or 1 date - show datepicker -->
                      <ng-container *ngIf="codicilDates.length <= 1">
                        <div class="codicil-date-input-wrapper">
                          <input class="form-input codicil-date-input"
                                 [matDatepicker]="codicilSinglePicker"
                                 [value]="getSingleCodicilMoment()"
                                 (dateChange)="onSingleCodicilDateChange($event.value)"
                                 (keypress)="onDateInputKeyPress($event)"
                                 (input)="onSingleCodicilTextInput($event)"
                                 (blur)="onSingleCodicilTextBlur($event)"
                                 maxlength="10"
                                 inputmode="numeric"
                                 placeholder="DD/MM/YYYY">
                          <button type="button" class="codicil-cal-btn" (click)="codicilSinglePicker.open()" tabindex="-1">
                            <mat-icon>calendar_today</mat-icon>
                          </button>
                          <mat-datepicker #codicilSinglePicker></mat-datepicker>
                        </div>
                        <button *ngIf="codicilDates.length === 1" type="button" class="codicil-remove-btn-small" (click)="removeCodicilDate(0)" title="Remove codicil date">×</button>
                      </ng-container>
                      
                      <!-- Multiple dates - show as dropdown -->
                      <ng-container *ngIf="codicilDates.length > 1">
                        <select class="form-input codicil-dropdown" [(ngModel)]="selectedCodicilIndex" name="codicilSelect">
                          <option *ngFor="let date of codicilDates; let i = index" [ngValue]="i">{{ date }}</option>
                        </select>
                        <button type="button" class="codicil-remove-btn-small" (click)="removeCodicilDate(selectedCodicilIndex)" title="Remove selected">×</button>
                      </ng-container>
                      
                      <!-- Add button / inline add row -->
                      <button *ngIf="!showCodicilPopup" type="button" class="codicil-add-btn" (click)="openCodicilPopup()" title="Add codicil date">+</button>
                      <ng-container *ngIf="showCodicilPopup">
                        <div class="codicil-date-input-wrapper">
                          <input class="form-input codicil-date-input"
                                 [matDatepicker]="newCodicilPicker"
                                 [(ngModel)]="newCodicilMoment" name="newCodicilMoment"
                                 (keypress)="onDateInputKeyPress($event)"
                                 (input)="onNewCodicilTextInput($event)"
                                 (blur)="onNewCodicilTextBlur($event)"
                                 maxlength="10"
                                 inputmode="numeric"
                                 placeholder="DD/MM/YYYY">
                          <button type="button" class="codicil-cal-btn" (click)="newCodicilPicker.open()" tabindex="-1">
                            <mat-icon>calendar_today</mat-icon>
                          </button>
                          <mat-datepicker #newCodicilPicker></mat-datepicker>
                        </div>
                        <button type="button" class="codicil-popup-add" (click)="confirmAddCodicilDate()">Add</button>
                        <button type="button" class="codicil-popup-cancel" (click)="closeCodicilPopup()">×</button>
                      </ng-container>
                    </div>
                  </div>
                  <div class="date-field" style="display: flex; align-items: flex-end; padding-bottom: 6px;">
                    <label class="missing-page-label">
                      <input type="checkbox" [(ngModel)]="editableWill.missingPage" name="missingPage"
                             (change)="markAsChanged()" class="missing-page-checkbox">
                      Incomplete
                    </label>
                  </div>
                </div>
              </div>
          </div>

          <!-- Deceased Former Addresses Section -->
          <div class="static-section">
            <div class="static-section-header">
              <h3 class="section-title" style="margin: 0; border: none; padding: 0;">
                Deceased Former Addresses
                <span class="info-icon-header" [matTooltip]="getDeceasedAddressTooltip()"
                      matTooltipPosition="right">ℹ</span>
              </h3>
            </div>
              <div class="section-content">
                <!-- Default flat view (before clicking Add Additional) -->
                @if (!formerAddressesGrouped) {
                <div class="five-column-form">
                  <div class="form-row">
                    <label class="form-label">Address</label>
                    <input type="text" class="form-input" [(ngModel)]="_pendingFormerAddress.address"
                           name="defaultFormerAddress"
                           (dblclick)="openTextPopup('formerAddress_address', -1)"
                           title="Double-click to expand" />
                  </div>
                  <div class="form-row">
                    <label class="form-label">Town</label>
                    <input type="text" class="form-input" [(ngModel)]="_pendingFormerAddress.town"
                           name="defaultFormerTown"
                           (dblclick)="openTextPopup('formerAddress_town', -1)"
                           title="Double-click to expand" />
                  </div>
                  <div class="form-row">
                    <label class="form-label">County</label>
                    <input type="text" class="form-input" [(ngModel)]="_pendingFormerAddress.county"
                           name="defaultFormerCounty"
                           (dblclick)="openTextPopup('formerAddress_county', -1)"
                           title="Double-click to expand" />
                  </div>
                  <div class="form-row">
                    <label class="form-label">Postcode</label>
                    <input type="text" class="form-input short" [(ngModel)]="_pendingFormerAddress.postcode"
                           name="defaultFormerPostcode"
                           (dblclick)="openTextPopup('formerAddress_postcode', -1)"
                           title="Double-click to expand" />
                  </div>
                  <div class="form-row">
                    <label class="form-label">Country</label>
                    <input type="text" class="form-input" [(ngModel)]="_pendingFormerAddress.country"
                           name="defaultFormerCountry"
                           (dblclick)="openTextPopup('formerAddress_country', -1)"
                           title="Double-click to expand" />
                  </div>
                </div>
                }

                <!-- Grouped view (after clicking Add Additional) -->
                @if (formerAddressesGrouped) {
                <mat-accordion multi="false" class="former-address-accordion">
                  @for(address of formerAddresses; track address.id; let idx = $index)
                  {
                  <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header class="panelHeader former-address-header">
                      <mat-panel-title>
                        <span>Former Address {{idx + 1}}</span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="former-address-content">
                      <div class="former-address-grid-5col">
                        <div class="former-address-field">
                          <label class="form-label">Address</label>
                          <input type="text" class="form-input" [(ngModel)]="address.address"
                                 name="formerAddress{{address.id}}"
                                 (dblclick)="openTextPopup('formerAddress_address', address.id)"
                                 title="Double-click to expand" />
                        </div>
                        <div class="former-address-field">
                          <label class="form-label">Town</label>
                          <input type="text" class="form-input" [(ngModel)]="address.town"
                                 name="formerTown{{address.id}}"
                                 (dblclick)="openTextPopup('formerAddress_town', address.id)"
                                 title="Double-click to expand" />
                        </div>
                        <div class="former-address-field">
                          <label class="form-label">County</label>
                          <input type="text" class="form-input" [(ngModel)]="address.county"
                                 name="formerCounty{{address.id}}"
                                 (dblclick)="openTextPopup('formerAddress_county', address.id)"
                                 title="Double-click to expand" />
                        </div>
                        <div class="former-address-field">
                          <label class="form-label">Postcode</label>
                          <input type="text" class="form-input" [(ngModel)]="address.postcode"
                                 name="formerPostcode{{address.id}}"
                                 (dblclick)="openTextPopup('formerAddress_postcode', address.id)"
                                 title="Double-click to expand" />
                        </div>
                        <div class="former-address-field">
                          <label class="form-label">Country</label>
                          <input type="text" class="form-input" [(ngModel)]="address.country"
                                 name="formerCountry{{address.id}}"
                                 (dblclick)="openTextPopup('formerAddress_country', address.id)"
                                 title="Double-click to expand" />
                        </div>
                      </div>
                      <div class="former-address-actions">
                        <button type="button" class="btn" (click)="removeFormerAddress(address.id)">
                          Remove Former Address
                        </button>
                      </div>
                    </div>
                  </mat-expansion-panel>
                  }
                </mat-accordion>
                }

                <button type="button" class="btn btn-secondary add-btn" (click)="addFormerAddress()"
                  style="margin-top: 15px;">
                  Add Additional
                </button>
              </div>
          </div>

          <!-- Executor Relationship Section -->
          <div class="static-section">
            <div class="static-section-header">
              <h3 class="section-title" style="margin: 0; border: none; padding: 0;">
                Executor Relationship
                <span class="info-icon-header" [matTooltip]="getExecutorTooltip()"
                      matTooltipPosition="right">ℹ</span>
              </h3>
            </div>
              <div class="section-content">
                @for(executor of executors; track executor.trackingId; let idx = $index)
                {
                <div class="executor-row" style="display: flex; gap: 15px; align-items: flex-end; margin-bottom: 15px;">
                  <div class="form-row" style="flex: 1;">
                    <label class="form-label">Executor Name</label>
                    <input type="text" class="form-input" [(ngModel)]="executor.name"
                           name="executorRelName{{executor.trackingId}}"
                           (dblclick)="openTextPopup('executor_name', executor.trackingId)"
                           title="Double-click to expand" />
                  </div>
                  <div class="form-row" style="flex: 1;">
                    <label class="form-label">Relationship to Deceased</label>
                    <input type="text" class="form-input" [(ngModel)]="executor.relationship"
                           name="executorRelationship{{executor.trackingId}}"
                           (dblclick)="openTextPopup('executor_relationship', executor.trackingId)"
                           title="Double-click to expand" />
                  </div>
                  <div *ngIf="executor.isNewlyAdded">
                    <button type="button" class="btn btn-secondary" (click)="removeExecutor(executor.trackingId)">
                      Remove Executor
                    </button>
                  </div>
                </div>
                }
                <button type="button" class="btn btn-secondary add-btn" (click)="addExecutor()"
                  style="margin-top: 15px; display: block;">
                  Add Executor
                </button>
              </div>
          </div>

        </form>
      </div>

      <!-- Charitable Bequests Content -->
      <div class="bequest-content" cdkScrollable *ngIf="activeTab && activeTab.type == 'will' && activeBequestTab == 'charitable'"
        (input)="markAsChanged()" (change)="markAsChanged()">
        <!-- Sticky Header -->
        <div class="bequest-header-row sticky-header">
          <h2 class="section-title" style="font-size: 18px; margin: 0;">CHARITABLE BEQUESTS
            ({{charitableRawBequests.length}})</h2>
            <div class="header-buttons">
              <button type="button" class="btn delete-selected-btn"
                      [disabled]="!hasAnyBequestSelected()"
                      (click)="deleteSelectedBequests()">Delete Selected</button>
              <button type="button" class="btn duplicate-bequest-btn"
                      (click)="duplicateSelectedBequest()"
                      [disabled]="!hasSelectedBequest()"
                      [class.disabled]="!hasSelectedBequest()"
                      title="Duplicate selected bequest">Duplicate Bequest</button>
              <button type="button" class="btn add-additional-header-btn" (click)="addIndependentCharitableBequest()">+ Add Bequest</button>
              <button type="button" class="btn add-precondition-header-btn" (click)="addNewPrecondition()">+ Add Precondition</button>
            </div>
        </div>

        <!-- Select All row -->
        <div class="bulk-select-row">
          <label class="bulk-select-all-label" title="Select all bequests">
            <input type="checkbox"
                   [checked]="areAllCharitableBequestsSelected()"
                   (change)="toggleSelectAllCharitableBequests($any($event.target).checked)"
                   class="bulk-select-checkbox" />
            <span>Select All</span>
          </label>
        </div>
        
        <div class="bequest-section">
          <!-- Recursive template for nested preconditions -->
          <ng-template #preconditionTemplate let-nodes="nodes" let-depth="depth">
            @for(preconditionNode of nodes; track preconditionNode.key)
            {
            <div class="precondition-wrapper" [style.margin-left.px]="depth * 30">
              <div class="bequestControl precondition-with-button">
                <div class="precondition-field-wrapper" [class.nested-precondition-wrapper]="depth > 0">
                  <mat-form-field class="yellow-field bequestFormField">
                    <mat-label>{{ depth > 0 ? 'Child Pre-Condition' : 'Pre - Condition' }}</mat-label>
                    <input matInput #preconditionInput
                           [value]="getPreConditionDisplayValue(preconditionNode.key)"
                           (blur)="onPreConditionInput(preconditionNode.key, preconditionInput.value)"
                           (keydown.enter)="onPreConditionInput(preconditionNode.key, preconditionInput.value); $event.target.blur()"
                           (dblclick)="openTextPopup('precondition', undefined, preconditionNode.key)" />
                  </mat-form-field>
                </div>
                <button type="button" class="add-child-precondition-btn" (click)="addChildPrecondition(preconditionNode)"
                        title="Add Child PreCondition">
                  +
                </button>
                <button type="button" class="remove-precondition-btn" (click)="removeStandalonePrecondition(preconditionNode.key)"
                        title="Remove PreCondition">
                  ×
                </button>
              </div>
              <div class="indented-bequest-accordion" cdkDropList [cdkDropListData]="{precondition: preconditionNode.key}"
                [cdkDropListConnectedTo]="getAllDropListIds()" [id]="'precondition-list-' + preconditionNode.key"
                (cdkDropListDropped)="onDropToPrecondition($event, preconditionNode.key)"
                [cdkDropListAutoScrollStep]="28">
                <!-- Bequests assigned to this precondition -->
                @for(BequestItemOf of getBequestsForStandalonePrecondition(preconditionNode.key); track BequestItemOf.id)
            {
            <div class="charity-panel-container" cdkDrag [cdkDragData]="BequestItemOf"
              (cdkDragStarted)="onDragStarted(BequestItemOf)" (cdkDragEnded)="onDragEnded()"
              [class.co-dragging]="isDragging && currentlyDraggingBequest?.isDone && BequestItemOf.isDone && BequestItemOf.id !== currentlyDraggingBequest?.id">
              <div class="bequest-drag-placeholder" *cdkDragPlaceholder></div>
              <!-- Drag preview: stacked cards for multi-select, single pill otherwise -->
              <div class="bequest-drag-preview" *cdkDragPreview>
                <ng-container *ngIf="BequestItemOf.isDone && selectedCharitableBequestCount > 1">
                  <div class="drag-ghost-card drag-ghost-back-2"></div>
                  <div class="drag-ghost-card drag-ghost-back-1"></div>
                  <div class="drag-main-content">
                    <span class="drag-preview-text">{{(isLookupCompleted(BequestItemOf.id) && BequestItemOf.organisationName) ? BequestItemOf.organisationName : (BequestItemOf.name || 'Bequest')}}</span>
                    <span class="drag-count-badge">{{ selectedCharitableBequestCount }}</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="!(BequestItemOf.isDone && selectedCharitableBequestCount > 1)">
                  <span class="drag-preview-text">{{(isLookupCompleted(BequestItemOf.id) && BequestItemOf.organisationName) ? BequestItemOf.organisationName : (BequestItemOf.name || 'Bequest')}}</span>
                </ng-container>
              </div>
              <div class="co-dragging-badge" *ngIf="isDragging && currentlyDraggingBequest?.isDone && BequestItemOf.isDone && BequestItemOf.id !== currentlyDraggingBequest?.id">
                <span class="co-dragging-badge-text">Moving with selection</span>
              </div>
              <div class="charity-header-row">
                <label class="done-checkbox-wrapper" title="Mark as done">
                  <input type="checkbox" [(ngModel)]="BequestItemOf.isDone"
                    name="charitableDoneP{{BequestItemOf.id}}" class="done-checkbox-input" />
                  <span class="done-checkbox-custom" [class.checked]="BequestItemOf.isDone">
                    <svg viewBox="0 0 24 24" class="done-checkmark">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                    </svg>
                  </span>
                </label>
                <div class="charity-panel-wrapper" [class.panel-done]="BequestItemOf.isDone">
                  <mat-expansion-panel [expanded]="false" class="charity-bequest-panel"
                    [ngClass]="getBequestPanelClass(BequestItemOf.id)"
                    (opened)="onPanelOpened(BequestItemOf)">
                    <mat-expansion-panel-header class="panelHeader charity-panel-header"
                      [class.header-done]="BequestItemOf.isDone"
                      [ngClass]="getBequestColorClass(BequestItemOf.id)"
                      cdkDragHandle>
                      <mat-panel-title>
                        <button type="button" class="info-icon-btn info-icon-panel-left"
                          [matTooltip]="BequestItemOf.bequestText" matTooltipPosition="right"
                          matTooltipClass="bequest-info-tooltip" (click)="$event.stopPropagation()">
                          ℹ
                        </button>
                        <span class="charity-panel-text">
                          <span class="charity-name">{{(isLookupCompleted(BequestItemOf.id) && BequestItemOf.organisationName) ? BequestItemOf.organisationName : (BequestItemOf.name || 'New Beneficiary')}}</span>
                          <span class="charity-type" *ngIf="BequestItemOf.bequestSubType"> -
                            {{formatBequestType(BequestItemOf.bequestSubType)}}</span>
                          <span class="charity-value" *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'pecuniary' && BequestItemOf.cashAmount != null"> - £{{formatNumberWithCommas(BequestItemOf.cashAmount)}}</span>
                          <span class="charity-value" *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'residual' && BequestItemOf.percentageAmount != null"> - {{BequestItemOf.percentageAmount}}%</span>
                          <span class="charity-value" *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'effect' && BequestItemOf.effectDescription"> - {{BequestItemOf.effectDescription}}</span>
                        </span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="charity-bequest-content">
                      <!-- Two-column grid: Will data (left) | Linked data (right) -->
                      <div class="will-linked-grid">
                        <!-- Left Column: Data from Will -->
                        <div class="will-data-column">
                          <div class="column-header-row will-header-row">
                            <span class="column-header">From Will</span>
                          </div>
                          <mat-form-field class="grid-field name-on-will-field">
                            <mat-label>Name on Will</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.name"
                              name="charitableNameOnWillP{{BequestItemOf.id}}"
                              (ngModelChange)="onNameOnWillChange(BequestItemOf)"
                              (dblclick)="openTextPopup('nameOnWill', BequestItemOf.id)"
                              (keydown.enter)="openLookupWithCurrentData(BequestItemOf.id, $event)"
                              title="Double-click to expand, Enter to search" />
                            <label matSuffix class="show-name-checkbox"
                              *ngIf="BequestItemOf.name?.trim()">
                              <input type="checkbox" [(ngModel)]="BequestItemOf.beneficiaryNameOnWillVisible"
                                name="showNameOnWillP{{BequestItemOf.id}}" (change)="markAsChanged()" />
                              <span class="show-label">Show</span>
                            </label>
                          </mat-form-field>
                          <mat-form-field class="grid-field name-on-will-field">
                            <mat-label>CCN on Will</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.charityCommissionNumber"
                              name="charitableCCNOnWillP{{BequestItemOf.id}}"
                              (keydown.enter)="openLookupWithCurrentData(BequestItemOf.id, $event)"
                              title="Enter to search" />
                            <label matSuffix class="show-name-checkbox"
                              *ngIf="BequestItemOf.charityCommissionNumber?.trim()">
                              <input type="checkbox" [(ngModel)]="BequestItemOf.beneficiaryURNOnWillVisible"
                                name="showCCNOnWillP{{BequestItemOf.id}}" (change)="markAsChanged()" />
                              <span class="show-label">Show</span>
                            </label>
                          </mat-form-field>
                          <mat-form-field class="grid-field name-on-will-field">
                            <mat-label>Address on Will</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.beneficiaryAddressOnWill"
                              name="charitableAddressOnWillP{{BequestItemOf.id}}"
                              (dblclick)="openTextPopup('addressOnWill', BequestItemOf.id)"
                              (keydown.enter)="openLookupWithCurrentData(BequestItemOf.id, $event)"
                              title="Double-click to expand, Enter to search" />
                            <label matSuffix class="show-name-checkbox"
                              *ngIf="BequestItemOf.beneficiaryAddressOnWill?.trim()">
                              <input type="checkbox" [(ngModel)]="BequestItemOf.beneficiaryAddressOnWillVisible"
                                name="showAddressOnWillP{{BequestItemOf.id}}" (change)="markAsChanged()" />
                              <span class="show-label">Show</span>
                            </label>
                          </mat-form-field>
                        </div>

                        <!-- Right Column: Linked data from Lookup -->
                        <div class="linked-data-column">
                          <div class="column-header-row"
                            [class.lookup-header-disabled]="isBeneficiaryLinkingDisabled(BequestItemOf.id)"
                            [matTooltip]="isBeneficiaryLinkingDisabled(BequestItemOf.id) ? 'Beneficiary linking is not available for this service type' : ''"
                            [matTooltipShowDelay]="0" matTooltipClass="small-tooltip" matTooltipPosition="above">
                            <span class="column-header">Linked Beneficiary</span>
                            <span class="lookup-search-icon"
                              *ngIf="!isBeneficiaryLinkingDisabled(BequestItemOf.id)"
                              (click)="onLookupCharity(BequestItemOf.id)" title="Search Beneficiary">
                              🔍
                            </span>
                            <span class="lookup-disabled-icon"
                              *ngIf="isBeneficiaryLinkingDisabled(BequestItemOf.id)"
                              title="Beneficiary linking is not available for this service type">
                              🔍
                            </span>
                            <button type="button" class="clear-linked-btn"
                              *ngIf="isLookupCompleted(BequestItemOf.id)"
                              (click)="clearLinkedData(BequestItemOf.id)" title="Clear linked data">
                              ✕
                            </button>
                          </div>
                          <mat-form-field class="grid-field readonly-field">
                            <mat-label>Organisation Name</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.organisationName"
                              readonly
                              name="charitableOrganisationNameP{{BequestItemOf.id}}" />
                          </mat-form-field>
                          <mat-form-field class="grid-field readonly-field">
                            <mat-label>CCN Linked</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.ccnLinked"
                              readonly
                              name="charitableCCNLinkedP{{BequestItemOf.id}}" />
                          </mat-form-field>
                          <mat-form-field class="grid-field readonly-field">
                            <mat-label>Address Linked</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.addressLinked"
                              readonly
                              name="charitableAddressLinkedP{{BequestItemOf.id}}" />
                          </mat-form-field>
                        </div>
                      </div>

                      <!-- Row 3: Service Type | Trust/Discretionary Lookup based on selection -->
                      <div class="two-column-row">
                        <mat-form-field class="grid-field">
                          <mat-label>Service Type</mat-label>
                          <mat-select [(ngModel)]="BequestItemOf.notificationType"
                            name="charitableServiceTypeP{{BequestItemOf.id}}"
                            (ngModelChange)="onNotificationTypeChange(BequestItemOf)">
                            <mat-option value="">Select Type</mat-option>
                            <mat-option value="named">NAMED</mat-option>
                            <mat-option value="trust">TRUST</mat-option>
                            <mat-option value="discretionary">DISCRETIONARY</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <!-- Named lookup field - shows when NAMED is selected -->
                        <mat-form-field class="grid-field named-lookup-field"
                          [class.named-lookup-disabled]="isLookupCompleted(BequestItemOf.id)"
                          *ngIf="BequestItemOf.notificationType === 'named' && !isWillTrustBequestType(BequestItemOf.bequestSubType)"
                          [matTooltip]="isLookupCompleted(BequestItemOf.id) ? 'Beneficiary Category can not be selected. Beneficiary is selected by lookup' : ''"
                          [matTooltipShowDelay]="0" matTooltipClass="small-tooltip" matTooltipPosition="above">
                          <mat-label>Beneficiary Category</mat-label>
                          <input matInput readonly 
                            [value]="BequestItemOf.selectedNamedActivity ? BequestItemOf.selectedNamedActivity.category + ' - ' + BequestItemOf.selectedNamedActivity.activity : ''"
                            (click)="!isLookupCompleted(BequestItemOf.id) && onNamedLookup(BequestItemOf.id)"
                            name="charitableNamedLookupP{{BequestItemOf.id}}"
                            [style.cursor]="isLookupCompleted(BequestItemOf.id) ? 'default' : 'pointer'" />
                          <button matSuffix type="button" class="clear-linked-btn"
                            *ngIf="hasNamedCategory(BequestItemOf.id) && !isLookupCompleted(BequestItemOf.id)"
                            (click)="clearNamedCategory(BequestItemOf.id); $event.stopPropagation()" title="Clear category">
                            ✕
                          </button>
                          <span matSuffix class="lookup-search-icon"
                            *ngIf="!hasNamedCategory(BequestItemOf.id) && !isLookupCompleted(BequestItemOf.id)"
                            (click)="onNamedLookup(BequestItemOf.id); $event.stopPropagation()" title="Open Beneficiary Category">
                            🔍
                          </span>
                        </mat-form-field>
                        <!-- Trust lookup field - shows when TRUST is selected and Will Trust is not chosen -->
                        <mat-form-field class="grid-field named-lookup-field"
                          [class.named-lookup-disabled]="isLookupCompleted(BequestItemOf.id)"
                          *ngIf="BequestItemOf.notificationType === 'trust' && !isWillTrustBequestType(BequestItemOf.bequestSubType)"
                          [matTooltip]="isLookupCompleted(BequestItemOf.id) ? 'Beneficiary Category can not be selected. Beneficiary is selected by lookup' : ''"
                          [matTooltipShowDelay]="0" matTooltipClass="small-tooltip" matTooltipPosition="above">
                          <mat-label>Beneficiary Category</mat-label>
                          <input matInput readonly
                            [value]="BequestItemOf.selectedTrustActivity ? BequestItemOf.selectedTrustActivity.category + ' - ' + BequestItemOf.selectedTrustActivity.activity : ''"
                            (click)="!isLookupCompleted(BequestItemOf.id) && onTrustCategoryLookup(BequestItemOf.id)"
                            name="charitableTrustLookupP{{BequestItemOf.id}}"
                            [style.cursor]="isLookupCompleted(BequestItemOf.id) ? 'default' : 'pointer'" />
                          <button matSuffix type="button" class="clear-linked-btn"
                            *ngIf="hasTrustCategory(BequestItemOf.id) && !isLookupCompleted(BequestItemOf.id)"
                            (click)="clearTrustCategory(BequestItemOf.id); $event.stopPropagation()" title="Clear category">
                            ✕
                          </button>
                          <span matSuffix class="lookup-search-icon"
                            *ngIf="!hasTrustCategory(BequestItemOf.id) && !isLookupCompleted(BequestItemOf.id)"
                            (click)="onTrustCategoryLookup(BequestItemOf.id); $event.stopPropagation()" title="Open Beneficiary Category">
                            🔍
                          </span>
                        </mat-form-field>
                        <!-- Discretionary lookup field - only shows when DISCRETIONARY is selected -->
                        <mat-form-field class="grid-field discretionary-lookup-field"
                          [class.has-chips]="BequestItemOf.selectedDiscretionaryActivities?.length"
                          *ngIf="BequestItemOf.notificationType === 'discretionary'">
                          <mat-label>Discretionary Lookup</mat-label>
                          <input matInput readonly [value]="BequestItemOf.selectedDiscretionaryActivities?.length ? ' ' : ''" style="opacity: 0; position: absolute; pointer-events: none;" />
                          <div class="selection-summary" *ngIf="BequestItemOf.selectedDiscretionaryActivities?.length"
                            (click)="onDiscretionaryLookup(BequestItemOf.id)"
                            title="Click to view/edit selections">
                            <span class="selection-count">{{ BequestItemOf.selectedDiscretionaryActivities?.length }}</span>
                            <span class="selection-text">{{ BequestItemOf.selectedDiscretionaryActivities?.length === 1 ? 'category' : 'categories' }} selected</span>
                          </div>
                          <button matSuffix type="button" class="ellipsis-btn"
                            (click)="onDiscretionaryLookup(BequestItemOf.id)" title="Open Discretionary Lookup">
                            ⋯
                          </button>
                        </mat-form-field>
                        <!-- Empty placeholder when not NAMED, TRUST or DISCRETIONARY -->
                        <div class="grid-field-placeholder"
                          *ngIf="BequestItemOf.notificationType !== 'discretionary' && BequestItemOf.notificationType !== 'named' && BequestItemOf.notificationType !== 'trust'">
                        </div>
                      </div>

                      <!-- Row 4: Bequest Type | Dynamic Value Field -->
                      <div class="two-column-row">
                        <mat-form-field class="grid-field">
                          <mat-label>Bequest Type</mat-label>
                          <mat-select [(ngModel)]="BequestItemOf.bequestSubType"
                            name="charitableBequestSubTypeP{{BequestItemOf.id}}"
                            (ngModelChange)="markAsChanged()">
                            <mat-option value="">Select Type</mat-option>
                            @for (bequestType of bequestTypeOptions; track bequestType.id) {
                              <mat-option [value]="bequestType.bequestTypeCode">{{ bequestType.bequestType }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                        <!-- Dynamic value field based on Bequest Type selection -->
                        <mat-form-field class="grid-field"
                          *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'pecuniary'">
                          <mat-label>Pecuniary</mat-label>
                          <span matTextPrefix>£</span>
                          <input matInput [(ngModel)]="BequestItemOf.cashAmountFormatted"
                            name="charitablePecuniaryP{{BequestItemOf.id}}" type="text" inputmode="decimal"
                            (input)="onCashAmountChange($event, BequestItemOf)" />
                          <label matSuffix class="show-name-checkbox" *ngIf="BequestItemOf.cashAmount != null">
                            <input type="checkbox" [(ngModel)]="BequestItemOf.bequestItemOnWillVisible"
                              name="showBequestItemPP{{BequestItemOf.id}}" (change)="markAsChanged()" />
                            <span class="show-label">Show</span>
                          </label>
                        </mat-form-field>
                        <mat-form-field class="grid-field"
                          *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'residual'">
                          <mat-label>Residual</mat-label>
                          <input matInput [(ngModel)]="BequestItemOf.percentageAmount"
                            name="charitableResidualP{{BequestItemOf.id}}" type="text" inputmode="decimal"
                            pattern="[0-9]*\.?[0-9]*" />
                          <span matTextSuffix>%</span>
                          <label matSuffix class="show-name-checkbox" *ngIf="BequestItemOf.percentageAmount != null">
                            <input type="checkbox" [(ngModel)]="BequestItemOf.bequestItemOnWillVisible"
                              name="showBequestItemRP{{BequestItemOf.id}}" (change)="markAsChanged()" />
                            <span class="show-label">Show</span>
                          </label>
                        </mat-form-field>
                        <mat-form-field class="grid-field"
                          *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'effect'">
                          <mat-label>Effect</mat-label>
                          <input matInput [(ngModel)]="BequestItemOf.effectDescription"
                            name="charitableEffectP{{BequestItemOf.id}}"
                            (dblclick)="openTextPopup('effectDescription', BequestItemOf.id)"
                            title="Double-click to expand" />
                          <label matSuffix class="show-name-checkbox" *ngIf="BequestItemOf.effectDescription?.trim()">
                            <input type="checkbox" [(ngModel)]="BequestItemOf.bequestItemOnWillVisible"
                              name="showBequestItemEP{{BequestItemOf.id}}" (change)="markAsChanged()" />
                            <span class="show-label">Show</span>
                          </label>
                        </mat-form-field>
                        <!-- Proceeds of Sale: Percentage and Estimated Value grouped on right side -->
                        <div class="pos-value-fields" *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'proceedsOfSale'">
                          <mat-form-field class="grid-field">
                            <mat-label>Percentage</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.percentageAmount"
                              name="charitablePosPercentP{{BequestItemOf.id}}" type="text" inputmode="decimal"
                              pattern="[0-9]*\.?[0-9]*" />
                            <span matTextSuffix>%</span>
                          </mat-form-field>
                          <mat-form-field class="grid-field">
                            <mat-label>Estimated Value</mat-label>
                            <span matTextPrefix>£</span>
                            <input matInput [(ngModel)]="BequestItemOf.cashAmountFormatted"
                              name="charitablePosEstValP{{BequestItemOf.id}}" type="text" inputmode="decimal"
                              (input)="onCashAmountChange($event, BequestItemOf)" />
                          </mat-form-field>
                        </div>
                        <!-- Empty placeholder when no bequest type selected -->
                        <div class="grid-field-placeholder" *ngIf="!getBequestValueType(BequestItemOf.bequestSubType)">
                        </div>
                      </div>

                      <!-- Associated Text from User -->
                      <div class="compact-row">
                        <mat-form-field class="compact-field-full">
                          <mat-label>Associated Text</mat-label>
                          <input matInput [(ngModel)]="BequestItemOf.associatedTextFromUser"
                            name="charitableAssociatedTextP{{BequestItemOf.id}}"
                            (dblclick)="openTextPopup('associatedTextFromUser', BequestItemOf.id)"
                            title="Double-click to expand" />
                        </mat-form-field>
                      </div>

                      <!-- Row 5: Wishes -->
                      <div class="compact-row">
                        <mat-form-field class="compact-field-full wishes-field">
                          <mat-label>Wishes</mat-label>
                          <input matInput [(ngModel)]="BequestItemOf.wishes"
                            name="charitableWishesP{{BequestItemOf.id}}"
                            (dblclick)="openWishesPopup(BequestItemOf.id)" title="Double-click to expand" />
                        </mat-form-field>
                      </div>

                      <!-- Remove button - removes the entire bequest line -->
                      <div class="compact-row remove-row">
                        <label class="choice-flag-label">
                          <input type="checkbox" [(ngModel)]="BequestItemOf.charityChoice"
                            name="charityChoiceP{{BequestItemOf.id}}" />
                          Choice Flag
                        </label>
                        <button type="button" class="btn btn-danger remove-bequest-btn"
                          (click)="removeCharitableBequest(BequestItemOf.id)">
                          Remove Bequest
                        </button>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>
              </div>
            </div>
            }
                <!-- Empty drop zone if no bequests assigned yet -->
                @if(getBequestsForStandalonePrecondition(preconditionNode.key).length === 0)
                {
                <div class="empty-precondition-dropzone">
                  <span class="dropzone-hint">
                    {{ (isDragging && currentlyDraggingBequest?.isDone && selectedCharitableBequestCount > 1)
                        ? 'Drop to move ' + selectedCharitableBequestCount + ' bequests here'
                        : 'Drag charity bequest bars here' }}
                  </span>
                </div>
                }
              </div>
              
              <!-- Recursively render child preconditions -->
              @if(preconditionNode.children && preconditionNode.children.length > 0) {
                <ng-container *ngTemplateOutlet="preconditionTemplate; context: { nodes: preconditionNode.children, depth: depth + 1 }"></ng-container>
              }
            </div>
            }
          </ng-template>

          <!-- Main flat list of all bequests (not assigned to user-created preconditions) -->
          <div class="main-list-container" [class.has-preconditions]="activeStandalonePreconditions.length > 0"
               cdkDropList id="main-bequest-list"
               [cdkDropListData]="{items: getUnassignedBequests()}"
               [cdkDropListConnectedTo]="getAllDropListIds()"
               (cdkDropListDropped)="onMainListDrop($event)"
               [cdkDropListAutoScrollStep]="28">

            <div class="main-list-header" *ngIf="activeStandalonePreconditions.length > 0">
              <span class="main-list-title">Absolute Bequests</span>
              <span class="main-list-hint">Drop here to remove from precondition</span>
            </div>
            
            <mat-accordion multi="true">
            @for(BequestItemOf of getUnassignedBequests(); track BequestItemOf.id)
            {

            <div class="charity-panel-container" cdkDrag [cdkDragData]="BequestItemOf"
              (cdkDragStarted)="onDragStarted(BequestItemOf)" (cdkDragEnded)="onDragEnded()"
              [class.co-dragging]="isDragging && currentlyDraggingBequest?.isDone && BequestItemOf.isDone && BequestItemOf.id !== currentlyDraggingBequest?.id">
              <!-- Drag placeholder - shows where item will be dropped -->
              <div class="bequest-drag-placeholder" *cdkDragPlaceholder></div>
              <!-- Drag preview: stacked cards for multi-select, single pill otherwise -->
              <div class="bequest-drag-preview" *cdkDragPreview>
                <ng-container *ngIf="BequestItemOf.isDone && selectedCharitableBequestCount > 1">
                  <div class="drag-ghost-card drag-ghost-back-2"></div>
                  <div class="drag-ghost-card drag-ghost-back-1"></div>
                  <div class="drag-main-content">
                    <span class="drag-preview-text">{{(isLookupCompleted(BequestItemOf.id) && BequestItemOf.organisationName) ? BequestItemOf.organisationName : (BequestItemOf.name || 'Bequest')}}</span>
                    <span class="drag-count-badge">{{ selectedCharitableBequestCount }}</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="!(BequestItemOf.isDone && selectedCharitableBequestCount > 1)">
                  <span class="drag-preview-text">{{(isLookupCompleted(BequestItemOf.id) && BequestItemOf.organisationName) ? BequestItemOf.organisationName : (BequestItemOf.name || 'Bequest')}}</span>
                </ng-container>
              </div>
              <div class="co-dragging-badge" *ngIf="isDragging && currentlyDraggingBequest?.isDone && BequestItemOf.isDone && BequestItemOf.id !== currentlyDraggingBequest?.id">
                <span class="co-dragging-badge-text">Moving with selection</span>
              </div>
              <!-- Header row: checkbox + green bar + lookup button -->
              <div class="charity-header-row">
                <label class="done-checkbox-wrapper" title="Mark as done">
                  <input type="checkbox" [(ngModel)]="BequestItemOf.isDone"
                    name="charitableDone{{BequestItemOf.id}}" class="done-checkbox-input" />
                  <span class="done-checkbox-custom" [class.checked]="BequestItemOf.isDone">
                    <svg viewBox="0 0 24 24" class="done-checkmark">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                    </svg>
                  </span>
                </label>
                <div class="charity-panel-wrapper" [class.panel-done]="BequestItemOf.isDone">
                  <mat-expansion-panel [expanded]="false" class="charity-bequest-panel"
                    [ngClass]="getBequestPanelClass(BequestItemOf.id)"
                    (opened)="onPanelOpened(BequestItemOf)">
                    <!-- Panel header - drag handle and click to expand/collapse -->
                    <mat-expansion-panel-header class="panelHeader charity-panel-header"
                                                [class.header-done]="BequestItemOf.isDone"
                      [ngClass]="getBequestColorClass(BequestItemOf.id)"
                      cdkDragHandle>
                      <mat-panel-title>
                        <button type="button" class="info-icon-btn info-icon-panel-left"
                          [matTooltip]="BequestItemOf.bequestText" matTooltipPosition="right"
                          matTooltipClass="bequest-info-tooltip" (click)="$event.stopPropagation()">
                          ℹ
                        </button>
                        <span class="charity-panel-text">
                          <span class="charity-name">{{(isLookupCompleted(BequestItemOf.id) && BequestItemOf.organisationName) ? BequestItemOf.organisationName : (BequestItemOf.name || 'New Beneficiary')}}</span>
                          <span class="charity-type" *ngIf="BequestItemOf.bequestSubType"> -
                            {{formatBequestType(BequestItemOf.bequestSubType)}}</span>
                          <span class="charity-value" *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'pecuniary' && BequestItemOf.cashAmount != null"> - £{{formatNumberWithCommas(BequestItemOf.cashAmount)}}</span>
                          <span class="charity-value" *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'residual' && BequestItemOf.percentageAmount != null"> - {{BequestItemOf.percentageAmount}}%</span>
                          <span class="charity-value" *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'effect' && BequestItemOf.effectDescription"> - {{BequestItemOf.effectDescription}}</span>
                        </span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                <div class="charity-bequest-content">
                  <!-- Two-column grid: Will data (left) | Linked data (right) -->
                  <div class="will-linked-grid">
                    <!-- Left Column: Data from Will -->
                    <div class="will-data-column">
                      <div class="column-header-row will-header-row">
                        <span class="column-header">From Will</span>
                      </div>
                      <mat-form-field class="grid-field name-on-will-field">
                        <mat-label>Name on Will</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.name"
                              name="charitableNameOnWill{{BequestItemOf.id}}"
                              (ngModelChange)="onNameOnWillChange(BequestItemOf)"
                              (dblclick)="openTextPopup('nameOnWill', BequestItemOf.id)"
                              (keydown.enter)="openLookupWithCurrentData(BequestItemOf.id, $event)"
                              title="Double-click to expand, Enter to search" />
                            <label matSuffix class="show-name-checkbox"
                              *ngIf="BequestItemOf.name?.trim()">
                              <input type="checkbox" [(ngModel)]="BequestItemOf.beneficiaryNameOnWillVisible"
                                name="showNameOnWill{{BequestItemOf.id}}" (change)="markAsChanged()" />
                              <span class="show-label">Show</span>
                            </label>
                      </mat-form-field>
                      <mat-form-field class="grid-field name-on-will-field">
                        <mat-label>CCN on Will</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.charityCommissionNumber"
                               name="charitableCCNOnWill{{BequestItemOf.id}}"
                               (keydown.enter)="openLookupWithCurrentData(BequestItemOf.id, $event)"
                               title="Enter to search" />
                            <label matSuffix class="show-name-checkbox"
                              *ngIf="BequestItemOf.charityCommissionNumber?.trim()">
                              <input type="checkbox" [(ngModel)]="BequestItemOf.beneficiaryURNOnWillVisible"
                                name="showCCNOnWill{{BequestItemOf.id}}" (change)="markAsChanged()" />
                              <span class="show-label">Show</span>
                            </label>
                      </mat-form-field>
                      <mat-form-field class="grid-field name-on-will-field">
                        <mat-label>Address on Will</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.beneficiaryAddressOnWill"
                              name="charitableAddressOnWill{{BequestItemOf.id}}"
                              (dblclick)="openTextPopup('addressOnWill', BequestItemOf.id)"
                              (keydown.enter)="openLookupWithCurrentData(BequestItemOf.id, $event)"
                              title="Double-click to expand, Enter to search" />
                            <label matSuffix class="show-name-checkbox">
                              <input type="checkbox" [(ngModel)]="BequestItemOf.beneficiaryAddressOnWillVisible"
                                name="showAddressOnWill{{BequestItemOf.id}}" (change)="markAsChanged()" />
                              <span class="show-label">Show</span>
                            </label>
                      </mat-form-field>
                    </div>

                    <!-- Right Column: Linked data from Lookup -->
                    <div class="linked-data-column">
                      <div class="column-header-row"
                        [class.lookup-header-disabled]="isBeneficiaryLinkingDisabled(BequestItemOf.id)"
                        [matTooltip]="isBeneficiaryLinkingDisabled(BequestItemOf.id) ? 'Beneficiary linking is not available for this service type' : ''"
                        [matTooltipShowDelay]="0" matTooltipClass="small-tooltip" matTooltipPosition="above">
                        <span class="column-header">Linked Beneficiary</span>
                        <span class="lookup-search-icon"
                          *ngIf="!isBeneficiaryLinkingDisabled(BequestItemOf.id)"
                          (click)="onLookupCharity(BequestItemOf.id)" title="Search Beneficiary">
                          🔍
                        </span>
                        <span class="lookup-disabled-icon"
                          *ngIf="isBeneficiaryLinkingDisabled(BequestItemOf.id)"
                          title="Beneficiary linking is not available for this service type">
                          🔍
                        </span>
                        <button type="button" class="clear-linked-btn"
                          *ngIf="isLookupCompleted(BequestItemOf.id)"
                          (click)="clearLinkedData(BequestItemOf.id)" title="Clear linked data">
                          ✕
                        </button>
                      </div>
                          <mat-form-field class="grid-field readonly-field">
                        <mat-label>Organisation Name</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.organisationName"
                               readonly
                              name="charitableOrganisationName{{BequestItemOf.id}}" />
                      </mat-form-field>
                          <mat-form-field class="grid-field readonly-field">
                        <mat-label>CCN Linked</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.ccnLinked"
                               readonly
                               name="charitableCCNLinked{{BequestItemOf.id}}" />
                      </mat-form-field>
                          <mat-form-field class="grid-field readonly-field">
                        <mat-label>Address Linked</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.addressLinked"
                               readonly
                              name="charitableAddressLinked{{BequestItemOf.id}}" />
                      </mat-form-field>
                    </div>
                  </div>

                      <!-- Row 3: Service Type | Trust/Discretionary Lookup based on selection -->
                      <div class="two-column-row">
                        <mat-form-field class="grid-field">
                      <mat-label>Service Type</mat-label>
                      <mat-select [(ngModel)]="BequestItemOf.notificationType"
                                  name="charitableServiceType{{BequestItemOf.id}}"
                                  (ngModelChange)="onNotificationTypeChange(BequestItemOf)">
                        <mat-option value="">Select Type</mat-option>
                        <mat-option value="named">NAMED</mat-option>
                        <mat-option value="trust">TRUST</mat-option>
                        <mat-option value="discretionary">DISCRETIONARY</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <!-- Named lookup field - shows when NAMED is selected -->
                        <mat-form-field class="grid-field named-lookup-field"
                          [class.named-lookup-disabled]="isLookupCompleted(BequestItemOf.id)"
                          *ngIf="BequestItemOf.notificationType === 'named' && !isWillTrustBequestType(BequestItemOf.bequestSubType)"
                          [matTooltip]="isLookupCompleted(BequestItemOf.id) ? 'Beneficiary Category can not be selected. Beneficiary is selected by lookup' : ''"
                          [matTooltipShowDelay]="0" matTooltipClass="small-tooltip" matTooltipPosition="above">
                          <mat-label>Beneficiary Category</mat-label>
                          <input matInput readonly 
                            [value]="BequestItemOf.selectedNamedActivity ? BequestItemOf.selectedNamedActivity.category + ' - ' + BequestItemOf.selectedNamedActivity.activity : ''"
                            (click)="!isLookupCompleted(BequestItemOf.id) && onNamedLookup(BequestItemOf.id)"
                            name="charitableNamedLookup{{BequestItemOf.id}}"
                            [style.cursor]="isLookupCompleted(BequestItemOf.id) ? 'default' : 'pointer'" />
                          <button matSuffix type="button" class="clear-linked-btn"
                            *ngIf="hasNamedCategory(BequestItemOf.id) && !isLookupCompleted(BequestItemOf.id)"
                            (click)="clearNamedCategory(BequestItemOf.id); $event.stopPropagation()" title="Clear category">
                            ✕
                          </button>
                          <span matSuffix class="lookup-search-icon"
                            *ngIf="!hasNamedCategory(BequestItemOf.id) && !isLookupCompleted(BequestItemOf.id)"
                            (click)="onNamedLookup(BequestItemOf.id); $event.stopPropagation()" title="Open Beneficiary Category">
                            🔍
                          </span>
                        </mat-form-field>
                        <!-- Trust lookup field - shows when TRUST is selected and Will Trust is not chosen -->
                        <mat-form-field class="grid-field named-lookup-field"
                          [class.named-lookup-disabled]="isLookupCompleted(BequestItemOf.id)"
                          *ngIf="BequestItemOf.notificationType === 'trust' && !isWillTrustBequestType(BequestItemOf.bequestSubType)"
                          [matTooltip]="isLookupCompleted(BequestItemOf.id) ? 'Beneficiary Category can not be selected. Beneficiary is selected by lookup' : ''"
                          [matTooltipShowDelay]="0" matTooltipClass="small-tooltip" matTooltipPosition="above">
                          <mat-label>Beneficiary Category</mat-label>
                          <input matInput readonly
                            [value]="BequestItemOf.selectedTrustActivity ? BequestItemOf.selectedTrustActivity.category + ' - ' + BequestItemOf.selectedTrustActivity.activity : ''"
                            (click)="!isLookupCompleted(BequestItemOf.id) && onTrustCategoryLookup(BequestItemOf.id)"
                            name="charitableTrustLookup{{BequestItemOf.id}}"
                            [style.cursor]="isLookupCompleted(BequestItemOf.id) ? 'default' : 'pointer'" />
                          <button matSuffix type="button" class="clear-linked-btn"
                            *ngIf="hasTrustCategory(BequestItemOf.id) && !isLookupCompleted(BequestItemOf.id)"
                            (click)="clearTrustCategory(BequestItemOf.id); $event.stopPropagation()" title="Clear category">
                            ✕
                          </button>
                          <span matSuffix class="lookup-search-icon"
                            *ngIf="!hasTrustCategory(BequestItemOf.id) && !isLookupCompleted(BequestItemOf.id)"
                            (click)="onTrustCategoryLookup(BequestItemOf.id); $event.stopPropagation()" title="Open Beneficiary Category">
                            🔍
                          </span>
                        </mat-form-field>
                    <!-- Discretionary lookup field - only shows when DISCRETIONARY is selected -->
                        <mat-form-field class="grid-field discretionary-lookup-field"
                          [class.has-chips]="BequestItemOf.selectedDiscretionaryActivities?.length"
                          *ngIf="BequestItemOf.notificationType === 'discretionary'">
                        <mat-label>Discretionary Lookup</mat-label>
                          <input matInput readonly [value]="BequestItemOf.selectedDiscretionaryActivities?.length ? ' ' : ''" style="opacity: 0; position: absolute; pointer-events: none;" />
                          <div class="selection-summary" *ngIf="BequestItemOf.selectedDiscretionaryActivities?.length"
                                (click)="onDiscretionaryLookup(BequestItemOf.id)"
                            title="Click to view/edit selections">
                            <span class="selection-count">{{ BequestItemOf.selectedDiscretionaryActivities?.length }}</span>
                            <span class="selection-text">{{ BequestItemOf.selectedDiscretionaryActivities?.length === 1 ? 'category' : 'categories' }} selected</span>
                          </div>
                          <button matSuffix type="button" class="ellipsis-btn"
                            (click)="onDiscretionaryLookup(BequestItemOf.id)" title="Open Discretionary Lookup">
                          ⋯
                        </button>
                      </mat-form-field>
                        <!-- Empty placeholder when not NAMED, TRUST or DISCRETIONARY -->
                        <div class="grid-field-placeholder"
                          *ngIf="BequestItemOf.notificationType !== 'discretionary' && BequestItemOf.notificationType !== 'named' && BequestItemOf.notificationType !== 'trust'">
                    </div>
                  </div>

                  <!-- Row 4: Bequest Type | Dynamic Value Field -->
                      <div class="two-column-row">
                        <mat-form-field class="grid-field">
                      <mat-label>Bequest Type</mat-label>
                      <mat-select [(ngModel)]="BequestItemOf.bequestSubType"
                                  name="charitableBequestSubType{{BequestItemOf.id}}"
                                  (ngModelChange)="markAsChanged()">
                        <mat-option value="">Select Type</mat-option>
                        @for (bequestType of bequestTypeOptions; track bequestType.id) {
                          <mat-option [value]="bequestType.bequestTypeCode">{{ bequestType.bequestType }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <!-- Dynamic value field based on Bequest Type selection -->
                        <mat-form-field class="grid-field"
                          *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'pecuniary'">
                      <mat-label>Pecuniary</mat-label>
                      <span matTextPrefix>£</span>
                          <input matInput [(ngModel)]="BequestItemOf.cashAmountFormatted"
                            name="charitablePecuniary{{BequestItemOf.id}}" type="text" inputmode="decimal"
                            (input)="onCashAmountChange($event, BequestItemOf)" />
                          <label matSuffix class="show-name-checkbox" *ngIf="BequestItemOf.cashAmount != null">
                            <input type="checkbox" [(ngModel)]="BequestItemOf.bequestItemOnWillVisible"
                              name="showBequestItemPC{{BequestItemOf.id}}" (change)="markAsChanged()" />
                            <span class="show-label">Show</span>
                          </label>
                    </mat-form-field>
                        <mat-form-field class="grid-field"
                          *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'residual'">
                      <mat-label>Residual</mat-label>
                          <input matInput [(ngModel)]="BequestItemOf.percentageAmount"
                            name="charitableResidual{{BequestItemOf.id}}" type="text" inputmode="decimal"
                             pattern="[0-9]*\.?[0-9]*" />
                      <span matTextSuffix>%</span>
                          <label matSuffix class="show-name-checkbox" *ngIf="BequestItemOf.percentageAmount != null">
                            <input type="checkbox" [(ngModel)]="BequestItemOf.bequestItemOnWillVisible"
                              name="showBequestItemRC{{BequestItemOf.id}}" (change)="markAsChanged()" />
                            <span class="show-label">Show</span>
                          </label>
                    </mat-form-field>
                        <mat-form-field class="grid-field"
                          *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'effect'">
                      <mat-label>Effect</mat-label>
                          <input matInput [(ngModel)]="BequestItemOf.effectDescription"
                             name="charitableEffect{{BequestItemOf.id}}"
                             (dblclick)="openTextPopup('effectDescription', BequestItemOf.id)"
                             title="Double-click to expand" />
                          <label matSuffix class="show-name-checkbox" *ngIf="BequestItemOf.effectDescription?.trim()">
                            <input type="checkbox" [(ngModel)]="BequestItemOf.bequestItemOnWillVisible"
                              name="showBequestItemEC{{BequestItemOf.id}}" (change)="markAsChanged()" />
                            <span class="show-label">Show</span>
                          </label>
                    </mat-form-field>
                    <!-- Proceeds of Sale: Percentage and Estimated Value grouped on right side -->
                        <div class="pos-value-fields" *ngIf="getBequestValueType(BequestItemOf.bequestSubType) === 'proceedsOfSale'">
                          <mat-form-field class="grid-field">
                            <mat-label>Percentage</mat-label>
                            <input matInput [(ngModel)]="BequestItemOf.percentageAmount"
                              name="charitablePosPercent{{BequestItemOf.id}}" type="text" inputmode="decimal"
                              pattern="[0-9]*\.?[0-9]*" />
                            <span matTextSuffix>%</span>
                          </mat-form-field>
                          <mat-form-field class="grid-field">
                            <mat-label>Estimated Value</mat-label>
                            <span matTextPrefix>£</span>
                            <input matInput [(ngModel)]="BequestItemOf.cashAmountFormatted"
                              name="charitablePosEstVal{{BequestItemOf.id}}" type="text" inputmode="decimal"
                              (input)="onCashAmountChange($event, BequestItemOf)" />
                          </mat-form-field>
                        </div>
                    <!-- Empty placeholder when no bequest type selected -->
                        <div class="grid-field-placeholder" *ngIf="!getBequestValueType(BequestItemOf.bequestSubType)">
                        </div>
                      </div>

                  <!-- Associated Text from User -->
                  <div class="compact-row">
                    <mat-form-field class="compact-field-full">
                      <mat-label>Associated Text</mat-label>
                      <input matInput [(ngModel)]="BequestItemOf.associatedTextFromUser"
                        name="charitableAssociatedText{{BequestItemOf.id}}"
                        (dblclick)="openTextPopup('associatedTextFromUser', BequestItemOf.id)"
                        title="Double-click to expand" />
                    </mat-form-field>
                  </div>

                  <!-- Row 5: Wishes -->
                  <div class="compact-row">
                        <mat-form-field class="compact-field-full wishes-field">
                      <mat-label>Wishes</mat-label>
                          <input matInput [(ngModel)]="BequestItemOf.wishes"
                            name="charitableWishes{{BequestItemOf.id}}"
                            (dblclick)="openWishesPopup(BequestItemOf.id)" title="Double-click to expand" />
                    </mat-form-field>
                  </div>

                  <!-- Remove button - removes the entire bequest line -->
                  <div class="compact-row remove-row">
                        <label class="choice-flag-label">
                          <input type="checkbox" [(ngModel)]="BequestItemOf.charityChoice"
                            name="charityChoice{{BequestItemOf.id}}" />
                          Choice Flag
                        </label>
                        <button type="button" class="btn btn-danger remove-bequest-btn"
                          (click)="removeCharitableBequest(BequestItemOf.id)">
                      Remove Bequest
                    </button>
                  </div>
                </div>
                  </mat-expansion-panel>
                </div>
              </div>
            </div>

            }

            <!-- Empty main list drop zone when all items are in preconditions -->
            @if(activeStandalonePreconditions.length > 0 && getUnassignedBequests().length === 0)
            {
            <div class="empty-main-list-dropzone">
              <span class="dropzone-hint">Drop charity bequest bars here to remove from precondition</span>
            </div>
            }

            </mat-accordion>
          </div>

          <!-- User-created Precondition boxes (supports nesting) -->
          <div class="preconditions-section" *ngIf="activeStandalonePreconditions.length > 0" style="margin-top: 20px;">
            <ng-container *ngTemplateOutlet="preconditionTemplate; context: { nodes: activeStandalonePreconditions, depth: 0 }"></ng-container>
          </div>

          <!-- Benham Clause Section -->
          <div class="notes-section">
            <mat-form-field class="notes-field">
              <mat-label>Benham Clause</mat-label>
              <input matInput [(ngModel)]="benhamClauseText" name="benhamClause" placeholder="Enter Benham Clause text"
                (dblclick)="openTextPopup('benhamClause')" title="Double-click to expand" />
            </mat-form-field>
          </div>

          <!-- Footer Section -->
          <div class="notes-section">
            <mat-form-field class="notes-field footer-field-with-button">
              <mat-label>Footer</mat-label>
              <input matInput [(ngModel)]="charitableBequestNotes" name="charitableBequestNotes"
                placeholder="Enter footer text here..." (dblclick)="openTextPopup('footer')"
                title="Double-click to expand" />
              <button matSuffix type="button" class="footer-add-btn-inside" (click)="openFooterPopup('charitable'); $event.stopPropagation()" title="Select from prepared texts">+</button>
            </mat-form-field>
          </div>

          <!-- Action Buttons -->
          <div class="form-actions">
            @if(isReporter()) {
              <button type="button" class="btn btn-secondary" (click)="assignToSupervisor()">Assign to Supervisor</button>
            }
            <div class="form-actions-right">
              @if(previewServiceTypes.length > 0) {
                <select class="form-input short preview-service-type-field" [(ngModel)]="selectedPreviewServiceType" name="previewServiceTypeCharitable"
                  [compareWith]="compareServiceTypes"
                  aria-label="Preview Type" title="Preview Type"
                  (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                  @for(svc of previewServiceTypes; track svc.id) {
                    <option [ngValue]="svc">{{ svc.name.replace('_', ' ') }}</option>
                  }
                </select>
              }
              <button type="button" class="btn btn-secondary" (click)="previewNotification()" [disabled]="previewServiceTypes.length > 0 && !selectedPreviewServiceType">Preview notification</button>
              @if(isReporter()) {
                <button type="button" class="btn btn-primary" (click)="onReportWill()">Will Reported</button>
              } @else {
                <button type="button" class="btn btn-primary" (click)="onVerifyWill()">Verify Will</button>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Non-Charitable Bequests Content -->
      <div class="bequest-content"
        *ngIf="activeTab && activeTab.type == 'will' && activeBequestTab == 'non-charitable'"
        (input)="markAsChanged()" (change)="markAsChanged()">
        <div class="bequest-section">
          <h2 class="section-title" style="font-size: 18px; margin-top: 0; margin-bottom: 15px;">NON-CHARITABLE BEQUESTS
            ({{nonCharitableRawBequests.length}})</h2>

          <!-- Outer Accordion: Wraps all beneficiaries -->
          <mat-accordion multi="false">
            <mat-expansion-panel [expanded]="false">
              <mat-expansion-panel-header class="panelHeader">
                <mat-panel-title>
                  <h3 class="section-title" style="margin: 0; border: none; padding: 0;">View All Beneficiaries</h3>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <!-- Inner Accordion: Individual beneficiaries -->
              <mat-accordion multi="true">
                @for(nonCharitableRawBequest of nonCharitableRawBequests; track nonCharitableRawBequest.id)
                {
                <mat-expansion-panel [expanded]="false">
                  <mat-expansion-panel-header class="panelHeader">
                    <mat-panel-title>
                      <table>
                        <tr>
                          <td>{{nonCharitableRawBequest.name || 'New Beneficiary'}}</td>
                        </tr>
                      </table>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <div>
                    <div class="bequestControl">
                      <mat-form-field class="bequestFormField">
                        <mat-label>Name On Will</mat-label>
                        <input matInput [(ngModel)]="nonCharitableRawBequest.name"
                               name="nonCharitableNameOnWill{{nonCharitableRawBequest.id}}" />
                      </mat-form-field>
                    </div>

                    <div class="bequestControl">
                      <mat-form-field class="bequestFormField">
                        <mat-label>Pre-Conditions</mat-label>
                        <input matInput [(ngModel)]="nonCharitableRawBequest.conditionText"
                               name="nonCharitablePreConditions{{nonCharitableRawBequest.id}}" />
                      </mat-form-field>
                    </div>

                    <div class="bequestControl">
                      <mat-form-field class="bequestFormField">
                        <mat-label>Organisation Name</mat-label>
                        <input matInput [(ngModel)]="nonCharitableRawBequest.organisationName"
                               name="nonCharitableOrganisationName{{nonCharitableRawBequest.id}}" />
                      </mat-form-field>
                    </div>

                    <div class="bequestControl">
                      <mat-form-field class="bequestFormField">
                        <mat-label>Address</mat-label>
                        <input matInput [(ngModel)]="nonCharitableRawBequest.beneficiaryAddressOnWill"
                               name="nonCharitableAddress{{nonCharitableRawBequest.id}}" />
                      </mat-form-field>
                    </div>

                    <!-- Service Type Row -->
                    <div class="bequestControl" style="display: flex; gap: 15px;">
                      <mat-form-field style="flex: 1;">
                        <mat-label>Service Type</mat-label>
                        <mat-select [(ngModel)]="nonCharitableRawBequest.notificationType"
                                    name="nonCharitableServiceType{{nonCharitableRawBequest.id}}"
                                    (ngModelChange)="markAsChanged()">
                          <mat-option value="">Select Type</mat-option>
                          <mat-option value="named">NAMED</mat-option>
                          <mat-option value="trust">TRUST</mat-option>
                          <mat-option value="discretionary">DISCRETIONARY</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <!-- Discretionary lookup field - only shows when DISCRETIONARY is selected -->
                      <div style="flex: 1;" *ngIf="nonCharitableRawBequest.notificationType === 'discretionary'">
                        <mat-form-field style="width: 100%;" class="discretionary-lookup-field"
                          [class.has-chips]="nonCharitableRawBequest.selectedDiscretionaryActivities?.length">
                          <mat-label>Discretionary Lookup</mat-label>
                          <input matInput readonly [value]="nonCharitableRawBequest.selectedDiscretionaryActivities?.length ? ' ' : ''" style="opacity: 0; position: absolute; pointer-events: none;" />
                          <div class="selection-summary" *ngIf="nonCharitableRawBequest.selectedDiscretionaryActivities?.length"
                                  (click)="onDiscretionaryLookup(nonCharitableRawBequest.id)"
                            title="Click to view/edit selections">
                            <span class="selection-count">{{ nonCharitableRawBequest.selectedDiscretionaryActivities?.length }}</span>
                            <span class="selection-text">{{ nonCharitableRawBequest.selectedDiscretionaryActivities?.length === 1 ? 'category' : 'categories' }} selected</span>
                          </div>
                          <button matSuffix type="button" class="ellipsis-btn"
                            (click)="onDiscretionaryLookup(nonCharitableRawBequest.id)" title="Open Discretionary Lookup">
                            ⋯
                          </button>
                        </mat-form-field>
                      </div>
                      <!-- Empty placeholder when not DISCRETIONARY -->
                      <div style="flex: 1;"
                        *ngIf="nonCharitableRawBequest.notificationType !== 'discretionary'">
                      </div>
                    </div>

                    <!-- Bequest Type Row with Dynamic Value Field -->
                    <div class="bequestControl" style="display: flex; gap: 15px;">
                      <mat-form-field style="flex: 1;">
                        <mat-label>Bequest Type</mat-label>
                        <mat-select [(ngModel)]="nonCharitableRawBequest.bequestSubType"
                                    name="nonCharitableBequestSubType{{nonCharitableRawBequest.id}}"
                                    (ngModelChange)="markAsChanged()">
                          <mat-option value="">Select Type</mat-option>
                          @for (bequestType of bequestTypeOptions; track bequestType.id) {
                            <mat-option [value]="bequestType.bequestTypeCode">{{ bequestType.bequestType }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <!-- Dynamic value field based on Bequest Type selection -->
                      <mat-form-field style="flex: 1;"
                        *ngIf="getBequestValueType(nonCharitableRawBequest.bequestSubType) === 'pecuniary'">
                        <mat-label>Pecuniary</mat-label>
                        <span matTextPrefix>£</span>
                        <input matInput [(ngModel)]="nonCharitableRawBequest.cashAmountFormatted"
                          name="nonCharitablePecuniary{{nonCharitableRawBequest.id}}" type="text"
                          inputmode="decimal"
                          (input)="onCashAmountChange($event, nonCharitableRawBequest)" />
                      </mat-form-field>
                      <mat-form-field style="flex: 1;"
                        *ngIf="getBequestValueType(nonCharitableRawBequest.bequestSubType) === 'residual'">
                        <mat-label>Residual</mat-label>
                        <input matInput [(ngModel)]="nonCharitableRawBequest.percentageAmount"
                          name="nonCharitableResidual{{nonCharitableRawBequest.id}}" type="text"
                          inputmode="decimal" pattern="[0-9]*\.?[0-9]*" />
                        <span matTextSuffix>%</span>
                      </mat-form-field>
                      <mat-form-field style="flex: 1;"
                        *ngIf="getBequestValueType(nonCharitableRawBequest.bequestSubType) === 'effect'">
                        <mat-label>Effect</mat-label>
                        <input matInput [(ngModel)]="nonCharitableRawBequest.effectDescription"
                               name="nonCharitableEffect{{nonCharitableRawBequest.id}}"
                               (dblclick)="openTextPopup('effectDescriptionNonCharitable', nonCharitableRawBequest.id)"
                               title="Double-click to expand" />
                      </mat-form-field>
                      <!-- Proceeds of Sale: Percentage and Estimated Value on same row as Bequest Type -->
                      <mat-form-field style="flex: 1;"
                        *ngIf="getBequestValueType(nonCharitableRawBequest.bequestSubType) === 'proceedsOfSale'">
                        <mat-label>Percentage</mat-label>
                        <input matInput [(ngModel)]="nonCharitableRawBequest.percentageAmount"
                          name="nonCharitablePosPercent{{nonCharitableRawBequest.id}}" type="text"
                          inputmode="decimal" pattern="[0-9]*\.?[0-9]*" />
                        <span matTextSuffix>%</span>
                      </mat-form-field>
                      <mat-form-field style="flex: 1;"
                        *ngIf="getBequestValueType(nonCharitableRawBequest.bequestSubType) === 'proceedsOfSale'">
                        <mat-label>Estimated Value</mat-label>
                        <span matTextPrefix>£</span>
                        <input matInput [(ngModel)]="nonCharitableRawBequest.cashAmountFormatted"
                          name="nonCharitablePosEstVal{{nonCharitableRawBequest.id}}" type="text"
                          inputmode="decimal"
                          (input)="onCashAmountChange($event, nonCharitableRawBequest)" />
                      </mat-form-field>
                      <!-- Empty placeholder when no bequest type selected -->
                      <div style="flex: 1;" *ngIf="!getBequestValueType(nonCharitableRawBequest.bequestSubType)"></div>
                    </div>
                    <!-- Proceeds of Sale: Description box below -->
                    <div class="bequestControl"
                      *ngIf="getBequestValueType(nonCharitableRawBequest.bequestSubType) === 'proceedsOfSale'">
                      <mat-form-field class="bequestFormField">
                        <mat-label>Description</mat-label>
                        <input matInput [(ngModel)]="nonCharitableRawBequest.effectDescription"
                          name="nonCharitablePosDesc{{nonCharitableRawBequest.id}}"
                          (dblclick)="openTextPopup('effectDescriptionNonCharitable', nonCharitableRawBequest.id)"
                          title="Double-click to expand" />
                      </mat-form-field>
                    </div>

                    <div class="bequestControl">
                      <mat-form-field class="bequestFormField">
                        <mat-label>Bequest Description</mat-label>
                        <input matInput [(ngModel)]="nonCharitableRawBequest.bequestText"
                               name="nonCharitableBequestDescription{{nonCharitableRawBequest.id}}" />
                      </mat-form-field>
                    </div>

                    <div class="bequestControl">
                      <mat-form-field class="bequestFormField">
                        <mat-label>Notes</mat-label>
                        <input matInput name="nonCharitableNotes{{nonCharitableRawBequest.id}}" />
                      </mat-form-field>
                    </div>

                    <!-- Remove button - only for newly added beneficiaries -->
                    <div class="bequestControl" *ngIf="nonCharitableRawBequest.isNewlyAdded">
                      <button type="button" class="btn btn-secondary"
                        (click)="removeNonCharitableBequest(nonCharitableRawBequest.id)">
                        Remove Bequest
                      </button>
                    </div>
                  </div>
                </mat-expansion-panel>
                }
              </mat-accordion>

              <button type="button" class="btn btn-secondary add-btn" (click)="addNonCharitableBequest()"
                style="margin-top: 15px; margin-bottom: 15px; display: block;">
                Add Additional
              </button>

            </mat-expansion-panel>
          </mat-accordion>

          <!-- Footer Section -->
          <div class="notes-section">
            <mat-form-field class="notes-field footer-field-with-button" appearance="outline">
              <mat-label>Footer</mat-label>
              <textarea matInput [(ngModel)]="nonCharitableBequestNotes" name="nonCharitableBequestNotes" rows="2"
                        placeholder="Enter footer text here..."></textarea>
              <button matSuffix type="button" class="footer-add-btn-inside" (click)="openFooterPopup('nonCharitable'); $event.stopPropagation()" title="Select from prepared texts">+</button>
            </mat-form-field>
          </div>

          <!-- Action Buttons -->
          <div class="form-actions">
            @if(isReporter()) {
              <button type="button" class="btn btn-secondary" (click)="assignToSupervisor()">Assign to Supervisor</button>
            }
            <div class="form-actions-right">
              @if(previewServiceTypes.length > 0) {
                <select class="form-input short preview-service-type-field" [(ngModel)]="selectedPreviewServiceType" name="previewServiceTypeNonCharitable"
                  [compareWith]="compareServiceTypes"
                  aria-label="Preview Type" title="Preview Type"
                  (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                  @for(svc of previewServiceTypes; track svc.id) {
                    <option [ngValue]="svc">{{ svc.name.replace('_', ' ') }}</option>
                  }
                </select>
              }
              <button type="button" class="btn btn-secondary" (click)="previewNotification()" [disabled]="previewServiceTypes.length > 0 && !selectedPreviewServiceType">Preview notification</button>
              @if(isReporter()) {
                <button type="button" class="btn btn-primary" (click)="onReportWill()">Will Reported</button>
              } @else {
                <button type="button" class="btn btn-primary" (click)="onVerifyWill()">Verify Will</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right side - PDF Display -->
    <div class="pdf-section">
      <div class="pdf-header">
        <div class="pdf-tabs">
          @for(probateTabToDisplay of probateTabsToDisplay; track probateTabToDisplay.index)
          {
          <button class="pdf-tab"
                  [class.active]="activeTab && activeTab.type == 'probate' && activeTab.index == probateTabToDisplay.index"
                  (click)="setActiveTab(probateTabToDisplay)">
            Grant of Probate {{ probateTabToDisplay.index }}
          </button>
          }
          
          <!-- Single Will Tab (when only one will) -->
          <button class="pdf-tab"
                  [class.active]="activeTab && activeTab.type == 'will' && activeTab.index == willTabsToDisplay[0].index"
            (click)="setActiveTab(willTabsToDisplay[0])" *ngIf="willTabsToDisplay.length === 1">
            {{ willTabsToDisplay[0].displayName }}
          </button>

          <!-- Final Will indicator (when single will) -->
          <span class="final-will-text" *ngIf="willTabsToDisplay.length === 1 && isSingleWillFinal()">Final Will</span>
          <span class="incomplete-will-text" *ngIf="willTabsToDisplay.length === 1 && editableWill.missingPage">Incomplete Will</span>
          
          <!-- Wills Dropdown (when multiple wills) -->
          <select class="will-dropdown" [(ngModel)]="selectedWillIndex" (change)="onWillSelected()"
                  *ngIf="willTabsToDisplay.length > 1">
            <option value="">Select Will</option>
            @for(willTab of willTabsToDisplay; track willTab.index)
            {
            <option [value]="willTab.index">{{ willTab.displayName }}</option>
            }
          </select>

          <!-- Final Will indicator (when multiple wills and one is selected) -->
          <span class="final-will-text" *ngIf="willTabsToDisplay.length > 1 && selectedWillIndex && isSelectedWillFinal()">Final Will</span>
          <span class="incomplete-will-text" *ngIf="willTabsToDisplay.length > 1 && selectedWillIndex && editableWill.missingPage">Incomplete Will</span>

        </div>
        <div class="pdf-actions">
          <input type="file" accept=".pdf" #willFileInput style="display:none" (change)="onWillFileSelected($event)">
          <button class="upload-will-btn" (click)="willFileInput.click()" [disabled]="willUploadPending">Upload Will PDF</button>
          <input type="file" accept=".pdf" #gopFileInput style="display:none" (change)="onGopFileSelected($event)">
          <button class="upload-gop-btn" (click)="gopFileInput.click()" [disabled]="hasExistingGop || gopUploadPending" [title]="hasExistingGop ? 'Grant of Probate already exists' : 'Upload Grant of Probate PDF'">Upload GOP PDF</button>
          <button class="open-new-window-btn" (click)="openInNewWindow()">Open in New Window</button>
          <button class="save-order-btn" *ngIf="hasPageOrderChanged" (click)="saveReorderedPages()">
            Save Reordered PDF
          </button>
        </div>

        <!-- Will PDF Upload Panel -->
        <div class="will-upload-panel" *ngIf="willUploadPending">
          <span class="will-upload-filename">{{ willUploadFile?.name }}</span>
          <label>Date of Will:
            <input type="date" [(ngModel)]="willUploadDate" class="will-upload-date-input">
          </label>
          <label class="will-upload-final-label">
            <input type="checkbox" [(ngModel)]="willUploadFinal"> Mark as Final Will
          </label>
          <button class="will-upload-confirm-btn" (click)="confirmWillUpload()" [disabled]="willUploadInProgress">
            {{ willUploadInProgress ? 'Uploading...' : 'Upload' }}
          </button>
          <button class="will-upload-cancel-btn" (click)="cancelWillUpload()" [disabled]="willUploadInProgress">Cancel</button>
        </div>

        <!-- GOP PDF Upload Panel -->
        <div class="will-upload-panel" *ngIf="gopUploadPending">
          <span class="will-upload-filename">{{ gopUploadFile?.name }}</span>
          <button class="will-upload-confirm-btn" (click)="confirmGopUpload()" [disabled]="gopUploadInProgress">
            {{ gopUploadInProgress ? 'Uploading...' : 'Upload' }}
          </button>
          <button class="will-upload-cancel-btn" (click)="cancelGopUpload()" [disabled]="gopUploadInProgress">Cancel</button>
        </div>
      </div>

      <!-- PDF Viewer with Page Thumbnails Sidebar -->
      <div class="pdf-reorder-view">
      <!-- Left sidebar - Page thumbnails (always visible) -->
      <div class="page-thumbnails-sidebar" cdkDropList (cdkDropListDropped)="dropPage($event)">
        <div class="sidebar-header">
          <h4>Pages ({{pdfPages.length}})</h4>
        </div>
        <div class="thumbnail-list">
            <div class="thumbnail-item" *ngFor="let page of pdfPages; let i = index" cdkDrag
              [class.active]="selectedPageIndex === i" (click)="selectPage(i)">
            <div class="drag-handle-vertical" cdkDragHandle>:::</div>
            <div class="thumbnail-preview">
                <pdf-viewer [src]="currentPdfUrl" [page]="page.originalIndex + 1" [zoom]="0.12" [show-all]="false"
                [render-text]="false">
              </pdf-viewer>
            </div>
            <div class="thumbnail-label">{{ i + 1 }}</div>
          </div>
        </div>
      </div>

      <!-- Right side - Full page preview -->
      <div class="page-preview-main">
        <!-- PDF Controls Toolbar -->
        <div class="pdf-controls-toolbar" *ngIf="pdfPages.length > 0">
          <!-- Search Section -->
          <div class="toolbar-section search-section">
              <input type="text" class="pdf-search-input" [(ngModel)]="pdfSearchQuery" (input)="onPdfSearch()"
                (keydown.enter)="findNextInPdf()" placeholder="Search in PDF..." name="pdfSearch">
            <span class="search-match-count" *ngIf="pdfSearchQuery && totalSearchMatches > 0">
              {{currentSearchMatch}} / {{totalSearchMatches}}
            </span>
              <button class="pdf-search-btn" (click)="findPreviousInPdf()"
                [disabled]="!pdfSearchQuery || totalSearchMatches === 0" title="Previous match">
              Prev
            </button>
              <button class="pdf-search-btn" (click)="findNextInPdf()"
                [disabled]="!pdfSearchQuery || totalSearchMatches === 0" title="Next match">
              Next
            </button>
              <button class="pdf-search-btn clear-btn" (click)="clearPdfSearch()" *ngIf="pdfSearchQuery"
                    title="Clear search">
              X
            </button>
          </div>

          <!-- View Controls Section -->
          <div class="toolbar-section view-controls">
            <button class="pdf-control-btn" (click)="zoomOut()" title="Zoom out">-</button>
            <div class="zoom-input-wrapper">
                <input type="number" class="zoom-input" [value]="currentZoom" (input)="onZoomInputChange($event)"
                  (blur)="normalizeZoomInput($event)" (keydown.enter)="confirmZoomInput($event)" min="25" max="400"
                     title="Zoom percentage" />
              <span class="zoom-suffix">%</span>
            </div>
            <button class="pdf-control-btn" (click)="zoomIn()" title="Zoom in">+</button>
            <button class="pdf-control-btn" (click)="downloadPdf()" title="Download">Download</button>
            <button class="pdf-control-btn" (click)="printPdf()" title="Print">Print</button>
          </div>
        </div>

        <div *ngIf="isLoadingPages" class="loading-overlay">
          <div class="spinner"></div>
          <p>Loading PDF pages...</p>
        </div>
        <div *ngIf="!isLoadingPages && pdfPages.length > 0" class="full-page-view" #fullPageView>
            <pdf-viewer *ngIf="showPdfViewer && pdfViewerSrc" [src]="pdfViewerSrc" [zoom]="currentZoom / 100"
              [show-all]="true" [render-text]="true" [original-size]="false" [autoresize]="false" [fit-to-page]="false"
              [show-borders]="false" (after-load-complete)="onPdfLoadComplete($event)"
            style="width: 100%; height: 100%; display: block;">
          </pdf-viewer>
          
          <!-- Generating preview overlay -->
          <div class="generating-overlay" *ngIf="isGeneratingPreview">
            <div class="generating-content">
              <div class="small-spinner"></div>
              <p>Updating preview...</p>
            </div>
          </div>
          
          <!-- Message overlay when order has changed -->
          <div class="reorder-message" *ngIf="hasPageOrderChanged && !isGeneratingPreview">
            <div class="message-content">
              <p>Page order changed. Click "Save Reordered PDF" to save the new arrangement.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

 <!-- Notes Modal -->
 <div class="notes-overlay" *ngIf="isNotesOpen" (mousedown)="onNotesOverlayMouseDown($event)">
   <div class="notes-dialog" cdkDrag cdkDragBoundary=".notes-overlay" (mousedown)="$event.stopPropagation()">

     <div class="notes-header" cdkDragHandle>
       <h3>Case Notes</h3>
       <button class="notes-close-btn" (click)="closeNotes()">✕</button>
     </div>

     <div class="notes-list">

       <!-- Existing Notes -->
       <div class="note-item" *ngFor="let n of notes; let i = index">
         <div class="note-meta">
              <span class="note-date">{{ n.dateAdded | date:'dd/MM/yyyy HH:mm' }}</span><span class="note-user">{{
                n.userDisplayName }} </span>
           <button class="delete-note-btn" (click)="deleteNote(i)">x</button>
         </div>
         <div class="note-text">
           {{n.textContent}}
         </div>
       </div>

       <!-- Add New Note -->
       <div class="new-note-box">
            <textarea class="new-note-text" [(ngModel)]="newNoteText" (keydown.enter)="addNoteFromEnter($event)"
                   placeholder="Add a new note..."></textarea>
            <button class="add-note-btn" (click)="addNote()" [disabled]="!newNoteText.trim()">
           Add Note
         </button>
       </div>

     </div>

   </div>
 </div>
    <!-- Beneficiary Lookup Popup -->
  <div class="charity-lookup-overlay" *ngIf="isCharityLookupOpen" (mousedown)="onLookupOverlayMouseDown($event)">
      <div class="charity-lookup-dialog" cdkDrag cdkDragBoundary=".charity-lookup-overlay"
        (mousedown)="$event.stopPropagation()">
        <div class="charity-lookup-header" cdkDragHandle>
          <h3>Beneficiary Lookup</h3>
        <button class="close-btn" (click)="closeCharityLookup()" title="Close">✕</button>
      </div>
      
      <div class="charity-lookup-content">
        <div class="search-fields-row">
          <div class="search-field search-field-large">
              <label>Beneficiary Name</label>
              <div class="input-with-clear">
                <input type="text" [(ngModel)]="beneficiarySearchQuery.beneficiaryName"
                  (ngModelChange)="onBeneficiaryNameInput($event)"
                  (keydown)="onBeneficiarySearchKeydown($event)" placeholder="Enter beneficiary name"
                   class="search-input" />
                <button type="button" class="clear-input-btn" 
                  [class.clear-btn-hidden]="!beneficiarySearchQuery.beneficiaryName"
                  [disabled]="!beneficiarySearchQuery.beneficiaryName"
                  (click)="beneficiarySearchQuery.beneficiaryName = ''; onBeneficiarySearch()">×</button>
              </div>
          </div>
          
          <div class="search-field search-field-urn">
              <label>URN</label>
              <div class="input-with-clear">
                <input type="text" [(ngModel)]="beneficiarySearchQuery.beneficiaryURN"
                  (keydown)="onBeneficiarySearchKeydown($event)" placeholder="" maxlength="12"
                   class="search-input" />
                <button type="button" class="clear-input-btn"
                  [class.clear-btn-hidden]="!beneficiarySearchQuery.beneficiaryURN"
                  [disabled]="!beneficiarySearchQuery.beneficiaryURN"
                  (click)="beneficiarySearchQuery.beneficiaryURN = ''; onBeneficiarySearch()">×</button>
              </div>
          </div>
          
          <div class="search-field search-field-postcode">
            <label>Postcode</label>
              <div class="input-with-clear">
                <input type="text" [(ngModel)]="beneficiarySearchQuery.postcode"
                  (keydown)="onBeneficiarySearchKeydown($event)" placeholder="Enter postcode" class="search-input" />
                <button type="button" class="clear-input-btn"
                  [class.clear-btn-hidden]="!beneficiarySearchQuery.postcode"
                  [disabled]="!beneficiarySearchQuery.postcode"
                  (click)="beneficiarySearchQuery.postcode = ''; onBeneficiarySearch()">×</button>
              </div>
          </div>
          
          <div class="search-field search-field-address">
            <label>Address</label>
              <div class="input-with-clear">
                <input type="text" [(ngModel)]="beneficiarySearchQuery.address"
                  (keydown)="onBeneficiarySearchKeydown($event)" placeholder="Enter address" class="search-input" />
                <button type="button" class="clear-input-btn"
                  [class.clear-btn-hidden]="!beneficiarySearchQuery.address"
                  [disabled]="!beneficiarySearchQuery.address"
                  (click)="beneficiarySearchQuery.address = ''; onBeneficiarySearch()">×</button>
              </div>
          </div>
          
          <div class="search-field search-field-button">
            <label>&nbsp;</label>
              <button class="search-btn" (click)="onBeneficiarySearch()">Search</button>
          </div>
        </div>
        
        <!-- Search Results Table -->
        <div class="search-results-container">
          <div class="results-table-wrapper">
              <table class="results-table" *ngIf="beneficiarySearchResults.length > 0">
              <thead>
                <tr>
                    <th class="sortable-th" (click)="sortLookupBy('name')">Beneficiary Name <span class="sort-indicator">{{ lookupSortColumn === 'name' ? (lookupSortDirection === 'asc' ? '▲' : '▼') : '⇅' }}</span></th>
                    <th class="sortable-th" (click)="sortLookupBy('beneficiarySourceURN')">URN <span class="sort-indicator">{{ lookupSortColumn === 'beneficiarySourceURN' ? (lookupSortDirection === 'asc' ? '▲' : '▼') : '⇅' }}</span></th>
                  <th class="sortable-th" (click)="sortLookupBy('postcode')">Postcode <span class="sort-indicator">{{ lookupSortColumn === 'postcode' ? (lookupSortDirection === 'asc' ? '▲' : '▼') : '⇅' }}</span></th>
                  <th class="sortable-th" (click)="sortLookupBy('addressLine1')">Address <span class="sort-indicator">{{ lookupSortColumn === 'addressLine1' ? (lookupSortDirection === 'asc' ? '▲' : '▼') : '⇅' }}</span></th>
                  <th class="sortable-th" (click)="sortLookupBy('isClient')">Subscribed To <span class="sort-indicator">{{ lookupSortColumn === 'isClient' ? (lookupSortDirection === 'asc' ? '▲' : '▼') : '⇅' }}</span></th>
                  <th class="sortable-th" (click)="sortLookupBy('triggerHads')">HAD <span class="sort-indicator">{{ lookupSortColumn === 'triggerHads' ? (lookupSortDirection === 'asc' ? '▲' : '▼') : '⇅' }}</span></th>
                </tr>
              </thead>
              <tbody>

                  @for (result of beneficiarySearchResults; track result.id) {

                  <tr (click)="selectCharity(result)" (dblclick)="onCharityRowDoubleClick(result)"
                    (mouseenter)="hoveredRow = result.id" (mouseleave)="hoveredRow = null"
                    [class.selected]="selectedBeneficiaryForLookup?.id === result.id"
                    [class.hovered]="hoveredRow === result.id" [ngClass]="{'client-y-row': result.isClient}">

                    <!-- NAME COLUMN -->
                    <td>
                      <span #cell (mouseenter)="showTooltip(result.id, result.aliases, result.previousNames, cell)"
                        (mouseleave)="hideTooltip(result.id)"
                        style="cursor: pointer;">
                        {{ result.name }}
                      </span>
                    </td>

                    <td>{{result.beneficiarySourceURN}}</td>
                    <td>{{result.postcode}}</td>
                    <td>{{result.addressLine1}}
                      {{result.addressLine2}} {{result.addressLine3}} {{result.addressLine4}} {{result.addressLine5}}
                    </td>
                    <td>{{result.isClient ? 'Y' : 'N'}}</td>
                    <td>{{result.triggerHads ? 'Y' : 'N'}}</td>
                </tr>
                  }
                </tbody>
              </table>
              <!--VS Added Form to add Beneficiaries to DB-->
              <div class="no-results" *ngIf="beneficiarySearchResults.length === 0">

                <p>No results found.</p>

                <button class="search-btn" (click)="toggleAddBeneficiaryForm()" *ngIf="!alert.text">
                  + Add Bequest / Beneficiary to database
                </button>
                <mat-expansion-panel [expanded]="showAddBeneficiaryForm" class="mt-2">

                  <form #form="ngForm" (ngSubmit)="saveNewBeneficiary(newBeneficiary,form)" class="two-column-row">

                    <mat-form-field class="grid-field">
                      <mat-label>URN</mat-label>
                      <input matInput [(ngModel)]="newBeneficiary.beneficiarySourceURN" name="beneficiarySourceURN">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                      <mat-label>Name</mat-label>
                      <input matInput [(ngModel)]="newBeneficiary.name" name="name">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                      <mat-label>Address Line 1</mat-label>
                      <input matInput [(ngModel)]="newBeneficiary.addressLine1" name="addressLine1">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                      <mat-label>Address Line 2</mat-label>
                      <input matInput [(ngModel)]="newBeneficiary.addressLine2" name="addressLine2">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                      <mat-label>Postcode</mat-label>
                      <input matInput [(ngModel)]="newBeneficiary.postcode" name="postcode">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                      <mat-label>Activities</mat-label>
                      <input matInput [(ngModel)]="newBeneficiary.activities" name="activities">
                    </mat-form-field>

                  </form>
                  <button class="apply-btn" type="submit">
                    Save
                  </button>

                </mat-expansion-panel>


                <div *ngIf="alert.text" [ngClass]="{'alert-success': alert.type === 'success', 'alert-failed': alert.type === 'error'}" class="alert">
                  <p>{{ alert.text }}</p>
                </div>



              </div>

            </div>
            <div class="results-count-updated" *ngIf="beneficiarySearchResults.length > 0">
              <p>Found {{beneficiarySearchResults.length}} result(s).</p>
            </div>

          </div>

            <!-- Apply Button Row with Results Count -->
          <div class="apply-button-beneficary">
            <button class="apply-btn" [routerLink]="['/admin-beneficiaries']">Add Beneficiary</button>
            <button class="apply-btn" [disabled]="!selectedBeneficiaryForLookup" (click)="applySelectedBeneficiary()">
              Apply
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- Wishes Text Popup -->
    <div class="wishes-popup-overlay" *ngIf="isWishesPopupOpen" (mousedown)="onWishesOverlayMouseDown($event)">
      <div class="wishes-popup-dialog" cdkDrag cdkDragBoundary=".wishes-popup-overlay"
        (click)="$event.stopPropagation()">
        <div class="wishes-popup-header" cdkDragHandle>
          <h3>Wishes</h3>
          <button class="close-btn" (click)="closeWishesPopup()" title="Close">✕</button>
        </div>
        <div class="wishes-popup-content">
          <textarea class="wishes-textarea" [(ngModel)]="wishesPopupText" placeholder="Enter wishes text here..."
            rows="12"></textarea>
        </div>
        <div class="wishes-popup-footer">
          <button class="btn btn-secondary" (click)="closeWishesPopup()">Cancel</button>
          <button class="btn btn-primary" (click)="applyWishesPopup()">Apply</button>
    </div>
  </div>
</div>

    <!-- Generic Text Popup (for Name on Will, Address on Will, etc.) -->
    <div class="text-popup-overlay" *ngIf="isTextPopupOpen" (mousedown)="onTextPopupOverlayMouseDown($event)">
      <div class="wishes-popup-dialog" cdkDrag cdkDragBoundary=".text-popup-overlay" (click)="$event.stopPropagation()">
        <div class="wishes-popup-header" cdkDragHandle>
          <h3>{{ textPopupTitle }}</h3>
          <button class="close-btn" (click)="closeTextPopup()" title="Close">✕</button>
        </div>
        <div class="wishes-popup-content">
          <textarea class="wishes-textarea" [(ngModel)]="textPopupValue"
            [placeholder]="'Enter ' + textPopupTitle.toLowerCase() + ' here...'" rows="12"></textarea>
        </div>
        <div class="wishes-popup-footer">
          <button class="btn btn-secondary" (click)="closeTextPopup()">Cancel</button>
          <button class="btn btn-primary" (click)="applyTextPopup()">Apply</button>
        </div>
      </div>
    </div>

    <!-- Trust Lookup Popup -->
    <div class="trust-popup-overlay" *ngIf="isTrustPopupOpen" (mousedown)="onTrustOverlayMouseDown($event)">
      <div class="trust-popup-dialog" cdkDrag cdkDragBoundary=".trust-popup-overlay" (click)="$event.stopPropagation()">
        <div class="trust-popup-header" cdkDragHandle>
          <h3>Trust</h3>
          <button class="close-btn" (click)="closeTrustPopup()" title="Close">✕</button>
        </div>
        <div class="trust-popup-content">
          <textarea class="trust-textarea" [(ngModel)]="trustPopupText" placeholder="Enter trust text here..."
            rows="12"></textarea>
        </div>
        <div class="trust-popup-footer">
          <button class="btn btn-secondary" (click)="closeTrustPopup()">Cancel</button>
          <button class="btn btn-primary" (click)="applyTrustPopup()">Apply</button>
        </div>
      </div>
    </div>

    <!-- Discretionary Popup -->
    <div class="trust-popup-overlay" *ngIf="isDiscretionaryPopupOpen" (mousedown)="onDiscretionaryOverlayMouseDown($event)">
      <div class="trust-popup-dialog" cdkDrag cdkDragBoundary=".trust-popup-overlay" (click)="$event.stopPropagation()">
        <div class="trust-popup-header" cdkDragHandle>
          <h3>Discretionary</h3>
          <button class="close-btn" (click)="closeDiscretionaryPopup()" title="Close">✕</button>
        </div>
        <div class="trust-popup-content">
          <textarea class="trust-textarea" [(ngModel)]="discretionaryPopupText"
            placeholder="Enter discretionary text here..." rows="12"></textarea>
        </div>
        <div class="trust-popup-footer">
          <button class="btn btn-secondary" (click)="closeDiscretionaryPopup()">Cancel</button>
          <button class="btn btn-primary" (click)="applyDiscretionaryPopup()">Apply</button>
        </div>
      </div>
    </div>

    <!-- Discretionary Category Lookup Popup -->
    <div class="category-popup-overlay" *ngIf="isDiscretionaryCategoryPopupOpen" (mousedown)="onDiscretionaryCategoryOverlayMouseDown($event)">
      <div class="category-popup-dialog category-popup-dialog-wide" cdkDrag cdkDragBoundary=".category-popup-overlay" (mousedown)="$event.stopPropagation()">
        <div class="category-popup-header" cdkDragHandle>
          <h3>Discretionary Lookup</h3>
          <button class="close-btn" (click)="closeDiscretionaryCategoryPopup()" title="Close">✕</button>
        </div>
        <div class="category-popup-content category-popup-single-column">
          <!-- Activities Column (Single list showing Parent - Child) -->
          <div class="activity-column activity-column-full">
            <div class="activity-column-header">ACTIVITIES</div>
            <div class="activity-search-box">
              <input type="text" placeholder="Search activities..." 
                [(ngModel)]="activitySearchTerm" 
                (ngModelChange)="filterActivities()"
                class="activity-search-input" />
            </div>
            <div class="activity-checkbox-list" [class.empty-list]="filteredActivitiesList.length === 0">
              <div *ngIf="filteredActivitiesList.length === 0" class="empty-list-message">
                No activities found
              </div>
              <label *ngFor="let activity of filteredActivitiesList" class="activity-checkbox-item">
                <input type="checkbox" 
                  [checked]="isActivitySelected(activity)"
                  (change)="toggleActivity(activity)" />
                <span class="checkbox-label">{{ activity.parent }} - {{ activity.child }}</span>
              </label>
            </div>
          </div>
        </div>
        
        <!-- Selected items as green chips -->
        <div class="selected-summary" *ngIf="selectedSubActivities.length > 0">
          <span class="summary-label">Selected ({{ selectedSubActivities.length }}):</span>
          <div class="selected-items-preview">
            <span *ngFor="let item of selectedSubActivities" class="selected-preview-chip selected-chip-green">
              {{ item.category }} - {{ item.activity }}
              <button type="button" class="chip-remove-btn" (click)="removeSelectedActivity(item)">×</button>
            </span>
          </div>
        </div>
        
        <div class="category-popup-footer">
          <button class="btn btn-secondary" (click)="closeDiscretionaryCategoryPopup()">Cancel</button>
          <button class="btn btn-primary" (click)="applyDiscretionaryCategories()">Done</button>
        </div>
      </div>
    </div>

    <!-- Named Category Lookup Popup (Single Select) -->
    <div class="category-popup-overlay" *ngIf="isNamedCategoryPopupOpen" (mousedown)="onNamedCategoryOverlayMouseDown($event)">
      <div class="category-popup-dialog category-popup-dialog-wide" cdkDrag cdkDragBoundary=".category-popup-overlay" (mousedown)="$event.stopPropagation()">
        <div class="category-popup-header" cdkDragHandle>
          <h3>Beneficiary Category</h3>
          <button class="close-btn" (click)="closeNamedCategoryPopup()" title="Close">✕</button>
        </div>
        <div class="category-popup-content category-popup-single-column">
          <div class="activity-column activity-column-full">
            <div class="activity-column-header">ACTIVITIES (select one)</div>
            <div class="activity-search-box">
              <input type="text" placeholder="Search activities..." 
                [(ngModel)]="namedActivitySearchTerm" 
                (ngModelChange)="filterNamedActivities()"
                class="activity-search-input" />
            </div>
            <div class="activity-checkbox-list" [class.empty-list]="filteredNamedActivitiesList.length === 0">
              <div *ngIf="filteredNamedActivitiesList.length === 0" class="empty-list-message">
                No activities found
              </div>
              <label *ngFor="let activity of filteredNamedActivitiesList" class="activity-checkbox-item"
                [class.named-selected]="isNamedActivitySelected(activity)"
                (click)="selectNamedActivity(activity); $event.preventDefault()">
                <input type="radio" 
                  [checked]="isNamedActivitySelected(activity)"
                  name="namedActivityRadio" />
                <span class="checkbox-label">{{ activity.parent }} - {{ activity.child }}</span>
              </label>
            </div>
          </div>
        </div>
        
        <div class="category-popup-footer">
          <button class="btn btn-secondary" (click)="closeNamedCategoryPopup()">Cancel</button>
          <button class="btn btn-primary" (click)="applyNamedCategory()">Done</button>
        </div>
      </div>
    </div>

    <!-- Trust Category Lookup Popup (Single Select - same as Named) -->
    <div class="category-popup-overlay" *ngIf="isTrustCategoryPopupOpen" (mousedown)="onTrustCategoryOverlayMouseDown($event)">
      <div class="category-popup-dialog category-popup-dialog-wide" cdkDrag cdkDragBoundary=".category-popup-overlay" (mousedown)="$event.stopPropagation()">
        <div class="category-popup-header" cdkDragHandle>
          <h3>Beneficiary Category</h3>
          <button class="close-btn" (click)="closeTrustCategoryPopup()" title="Close">✕</button>
        </div>
        <div class="category-popup-content category-popup-single-column">
          <div class="activity-column activity-column-full">
            <div class="activity-column-header">ACTIVITIES (select one)</div>
            <div class="activity-search-box">
              <input type="text" placeholder="Search activities..." 
                [(ngModel)]="trustActivitySearchTerm" 
                (ngModelChange)="filterTrustActivities()"
                class="activity-search-input" />
            </div>
            <div class="activity-checkbox-list" [class.empty-list]="filteredTrustActivitiesList.length === 0">
              <div *ngIf="filteredTrustActivitiesList.length === 0" class="empty-list-message">
                No activities found
              </div>
              <label *ngFor="let activity of filteredTrustActivitiesList" class="activity-checkbox-item"
                [class.named-selected]="isTrustActivitySelected(activity)"
                (click)="selectTrustActivity(activity); $event.preventDefault()">
                <input type="radio" 
                  [checked]="isTrustActivitySelected(activity)"
                  name="trustActivityRadio" />
                <span class="checkbox-label">{{ activity.parent }} - {{ activity.child }}</span>
              </label>
            </div>
          </div>
        </div>
        
        <div class="category-popup-footer">
          <button class="btn btn-secondary" (click)="closeTrustCategoryPopup()">Cancel</button>
          <button class="btn btn-primary" (click)="applyTrustCategory()">Done</button>
        </div>
      </div>
    </div>

    <!-- Delete Selected Bequests Confirmation Dialog -->
    @if(showDeleteBequestsConfirm) {
      <div style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:10000;">
        <div style="position:relative;background:white;border-radius:12px;box-shadow:0 8px 32px rgba(0,0,0,0.3);padding:40px 28px 28px;min-width:340px;max-width:460px;display:flex;flex-direction:column;gap:24px;">
          <button type="button" class="save-prompt-close" (click)="cancelDeleteSelectedBequests()" title="Close">&times;</button>
          <p style="margin:0;font-size:16px;font-weight:500;color:#1a1a2e;text-align:center;">Are you sure you want to delete the selected bequest(s)? This action cannot be undone.</p>
          <div style="display:flex;justify-content:center;gap:12px;">
            <button type="button" class="btn btn-secondary" (click)="cancelDeleteSelectedBequests()">CANCEL</button>
            <button type="button" class="btn delete-selected-btn" (click)="confirmDeleteSelectedBequests()">DELETE</button>
          </div>
        </div>
      </div>
    }

    <!-- Save Prompt Dialog -->
    @if(showSavePrompt) {
      <div style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:10000;">
        <div style="position:relative;background:white;border-radius:12px;box-shadow:0 8px 32px rgba(0,0,0,0.3);padding:40px 28px 28px;min-width:380px;max-width:480px;display:flex;flex-direction:column;gap:24px;">
          <button type="button" class="save-prompt-close" (click)="savePromptCancel()" title="Close">&times;</button>
          <p style="margin:0;font-size:16px;font-weight:500;color:#1a1a2e;text-align:center;">You have unsaved changes. Would you like to save before continuing?</p>
          <div style="display:flex;justify-content:center;gap:12px;">
            <button type="button" class="btn btn-secondary" (click)="savePromptYes()">DISCARD CHANGES</button>
            <button type="button" class="btn btn-primary" (click)="savePromptSaveAndContinue()">SAVE AND CONTINUE</button>
          </div>
        </div>
      </div>
    }

    <!-- Footer Selection Popup -->
    <div class="footer-popup-overlay" *ngIf="isFooterPopupOpen" (click)="closeFooterPopup()">
      <div class="footer-popup-dialog" cdkDrag cdkDragBoundary=".footer-popup-overlay" (click)="$event.stopPropagation()">
        <div class="footer-popup-header" cdkDragHandle>
          <h3>Select Footer Text</h3>
          <button class="close-btn" (click)="closeFooterPopup()" title="Close">✕</button>
        </div>
        <div class="footer-popup-content">
          <p class="footer-popup-hint">Select one or more prepared texts to add to the footer. Multiple selections will be pipe-separated ( | ).</p>
          <div class="footer-options-list">
            <div *ngFor="let option of allFooterOptions" 
                 class="footer-option-item" 
                 [class.selected]="option.selected"
                 (click)="toggleFooterOption(option)">
              <span class="footer-text">{{ option.footer }}</span>
            </div>
            <div *ngIf="allFooterOptions.length === 0" class="footer-empty-message">
              No prepared footer texts available.
            </div>
          </div>
        </div>
        <div class="footer-popup-actions">
          <button class="btn btn-secondary" (click)="closeFooterPopup()">Cancel</button>
          <button class="btn btn-primary" (click)="applyFooterSelections()">Add Selected</button>
        </div>
      </div>
    </div>

    <!-- Beneficiary Aliases & Former Names Tooltip (outside all dialogs to avoid transform issues) -->
    @for (result of beneficiarySearchResults; track result.id) {
      <div *ngIf="tooltipVisible[result.id]" class="hover-card-fixed"
        [ngStyle]="{ top: tooltipPosition[result.id]?.top + 'px', left: tooltipPosition[result.id]?.left + 'px' }"
        (mouseenter)="onTooltipMouseEnter(result.id)"
        (mouseleave)="onTooltipMouseLeave(result.id)">
        
        <div class="tooltip-columns">
          <!-- Aliases Section -->
          <div class="tooltip-column">
            <div class="tooltip-section-header">Aliases</div>
            <ng-container *ngIf="tooltipContent[result.id]?.aliases?.length; else noAliases">
              <div *ngFor="let alias of tooltipContent[result.id].aliases" class="tooltip-item">{{ alias }}</div>
            </ng-container>
            <ng-template #noAliases>
              <div class="tooltip-item-empty">None</div>
            </ng-template>
          </div>
          
          <!-- Former Names Section -->
          <div class="tooltip-column">
            <div class="tooltip-section-header">Former Names</div>
            <ng-container *ngIf="tooltipContent[result.id]?.previousNames?.length; else noFormerNames">
              <div *ngFor="let formerName of tooltipContent[result.id].previousNames" class="tooltip-item">{{ formerName }}</div>
            </ng-container>
            <ng-template #noFormerNames>
              <div class="tooltip-item-empty">None</div>
            </ng-template>
          </div>
        </div>
      </div>
    }
  </div>
